webpackJsonp([227973273683322],{

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LegendModule = __webpack_require__(135);
	
	var _LegendModule2 = _interopRequireDefault(_LegendModule);
	
	var _YearChange = __webpack_require__(98);
	
	var _YearChange2 = _interopRequireDefault(_YearChange);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var label = _ref.label,
	      symbols = _ref.symbols;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h3',
	      { className: _LegendModule2.default.title },
	      label
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _LegendModule2.default.legendContainer },
	      _react2.default.createElement(
	        'ul',
	        { className: _LegendModule2.default.legend },
	        Object.values(symbols).sort(function (a, b) {
	          return a.order > b.order;
	        }).map(function (v, i) {
	          return _react2.default.createElement(
	            'li',
	            { key: i },
	            _react2.default.createElement(
	              'svg',
	              { className: _LegendModule2.default.color },
	              _react2.default.createElement('path', {
	                d: v.d,
	                fill: v.fill,
	                transform: 'translate(5,5) scale(5)'
	              })
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'label' },
	              v.label
	            )
	          );
	        })
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _oesterreich_centerpoints = __webpack_require__(100);
	
	var _oesterreich_centerpoints2 = _interopRequireDefault(_oesterreich_centerpoints);
	
	var _FieldDefinitions = __webpack_require__(20);
	
	var _FieldDefinitions2 = _interopRequireDefault(_FieldDefinitions);
	
	var _Map = __webpack_require__(117);
	
	var _Map2 = _interopRequireDefault(_Map);
	
	var _topojsonClient = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var SYMBOL_SIZE = 2.4;
	
	function log(data) {
	  console.log(data);
	  return data;
	}
	
	exports.default = function (_ref) {
	  var field = _ref.field,
	      data = _ref.data,
	      symbols = _ref.symbols,
	      props = _objectWithoutProperties(_ref, ['field', 'data', 'symbols']);
	
	  var getData = function getData(iso) {
	    return (data.find(function (d) {
	      return d.node.iso === iso;
	    }) || {}).node;
	  };
	
	  var getPathProperties = function getPathProperties(iso) {
	    var d = getData(parseInt(iso));
	
	    var children = _react2.default.createElement(
	      'title',
	      null,
	      '' + d.name
	    );
	
	    return {
	      fill: 'white',
	      onClick: function onClick() {
	        props.clickOnGemeinde && props.clickOnGemeinde(iso);
	      },
	
	      children: children
	    };
	  };
	
	  var overlayObjects = function overlayObjects(d, i, projection) {
	    var r = 9;
	
	    var _projection = projection(_oesterreich_centerpoints2.default[d.properties.iso]),
	        cx = _projection[0],
	        cy = _projection[1];
	
	    var istBezirk = d.properties.iso.length === 3;
	
	    if (istBezirk) {
	      if (d.properties.iso != 103 && d.properties.iso != 102) return _react2.default.createElement(
	        'text',
	        { key: 'c_' + i, transform: 'translate(' + cx + ', ' + cy + ')' },
	        d.properties.name
	      );
	      return;
	    }
	
	    var scale = istBezirk ? 8 : 2;
	
	    var overlayData = istBezirk ? Object.entries(symbols).reduce(function (acc, _ref2) {
	      var field = _ref2[0],
	          symbol = _ref2[1];
	
	      acc[field] = data.filter(function (value) {
	        return value.iso.startsWith(d.properties.iso);
	      }).findIndex(function (value) {
	        return value[field] > 0;
	      }) != -1 ? 1 : 0;
	      return acc;
	    }, {}) : getData(parseInt(d.properties.iso));
	
	    var x = 0,
	        y = 0;
	
	    var overlaySymbols = Object.entries(symbols).reduce(function (acc, _ref3, i) {
	      var field = _ref3[0],
	          symbol = _ref3[1];
	
	      if (overlayData[field]) acc.push(Array(overlayData[field]).fill().map(function (x, i) {
	        return _react2.default.createElement('path', {
	          d: symbol.d,
	          fill: symbol.fill,
	          transform: 'translate(' + acc.length * SYMBOL_SIZE + ', ' + i * SYMBOL_SIZE + ')'
	        });
	      }));
	      return acc;
	    }, []);
	
	    var dx = (overlaySymbols.length - 1) * SYMBOL_SIZE / 2;
	    var dy = (overlaySymbols.reduce(function (acc, column) {
	      return Math.max(acc, column.length);
	    }, 0) - 1) * SYMBOL_SIZE / 2;
	
	    return cx && overlaySymbols.length && _react2.default.createElement(
	      'g',
	      {
	        key: 'c_' + i,
	        transform: 'translate(' + (cx - dx * scale) + ', ' + (cy - dy * scale) + ') scale(' + scale + ')'
	      },
	      overlaySymbols
	    );
	  };
	
	  return _react2.default.createElement(_Map2.default, _extends({
	    pathProperties: getPathProperties,
	    overlayObjects: overlayObjects,
	    className: 'symbolAtlas'
	  }, props));
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 100:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  '1': [16.8081, 47.8587],
	  '2': [14.4682, 46.7165],
	  '3': [15.6066, 48.4392],
	  '4': [13.8916, 48.1631],
	  '5': [13.2588, 47.3199],
	  '6': [15.3015, 47.3307],
	  '7': [10.8039, 47.1458],
	  '8': [9.8647, 47.246],
	  '9': [16.3732, 48.2068],
	  '101': [16.531, 47.8516],
	  '102': [16.6768, 47.8023],
	  '103': [16.6808, 47.8838],
	  '104': [16.3373, 47.0738],
	  '105': [16.2127, 46.9851],
	  '106': [16.3858, 47.7381],
	  '107': [16.8828, 47.8153],
	  '108': [16.4973, 47.5253],
	  '109': [16.2175, 47.3189],
	  '201': [14.3003, 46.6302],
	  '202': [13.8377, 46.6153],
	  '203': [13.2668, 46.6269],
	  '204': [14.3415, 46.5079],
	  '205': [14.4509, 46.8583],
	  '206': [13.2641, 46.8826],
	  '207': [13.6942, 46.6952],
	  '208': [14.6842, 46.6094],
	  '209': [14.835, 46.8755],
	  '210': [14.0568, 46.741],
	  '301': [15.6028, 48.4212],
	  '302': [15.6221, 48.2025],
	  '303': [14.774, 47.9491],
	  '304': [16.2405, 47.8149],
	  '305': [14.6243, 48.075],
	  '306': [16.1303, 47.9726],
	  '307': [16.74, 48.0675],
	  '308': [16.7562, 48.2419],
	  '309': [14.8783, 48.6869],
	  '310': [16.058, 48.5966],
	  '311': [15.6566, 48.7129],
	  '312': [16.2857, 48.4402],
	  '313': [15.4645, 48.5104],
	  '314': [15.6588, 47.9879],
	  '315': [15.1266, 48.2398],
	  '316': [16.5161, 48.6614],
	  '317': [16.2654, 48.0847],
	  '318': [16.0173, 47.6541],
	  '319': [15.8036, 48.1568],
	  '320': [15.1119, 47.9938],
	  '321': [15.9257, 48.3281],
	  '322': [15.3437, 48.8717],
	  '323': [15.8658, 47.8837],
	  '324': [16.5104, 48.0967],
	  '325': [15.1016, 48.515],
	  '401': [14.3232, 48.2569],
	  '402': [14.4172, 48.0516],
	  '403': [14.0257, 48.1787],
	  '404': [13.1271, 48.1492],
	  '405': [13.9877, 48.2935],
	  '406': [14.6246, 48.4608],
	  '407': [13.8015, 47.8367],
	  '408': [13.7623, 48.251],
	  '409': [14.2421, 47.766],
	  '410': [14.2588, 48.1725],
	  '411': [14.7544, 48.2521],
	  '412': [13.4549, 48.2554],
	  '413': [13.9358, 48.5479],
	  '414': [13.5745, 48.4693],
	  '415': [14.5583, 47.8547],
	  '416': [14.289, 48.4535],
	  '417': [13.5443, 47.9924],
	  '418': [13.8894, 48.1112],
	  '501': [13.0429, 47.798],
	  '502': [13.3438, 47.5946],
	  '503': [13.1589, 47.8901],
	  '504': [13.2761, 47.3503],
	  '505': [13.7239, 47.1501],
	  '506': [12.7904, 47.3021],
	  '601': [15.442, 47.0807],
	  '603': [15.1841, 46.819],
	  '606': [15.3021, 47.2198],
	  '610': [15.5256, 46.7721],
	  '611': [14.8434, 47.4741],
	  '612': [13.9858, 47.4473],
	  '614': [14.2214, 47.1911],
	  '616': [15.07, 47.0556],
	  '617': [15.6128, 47.3008],
	  '620': [14.7168, 47.2002],
	  '621': [15.3508, 47.5975],
	  '622': [15.9112, 47.2864],
	  '623': [15.8546, 46.9102],
	  '701': [11.3671, 47.2831],
	  '702': [10.8663, 47.2181],
	  '703': [11.2743, 47.1128],
	  '704': [12.478, 47.5018],
	  '705': [11.9863, 47.5189],
	  '706': [10.5253, 47.0828],
	  '707': [12.4834, 46.9721],
	  '708': [10.6216, 47.4403],
	  '709': [11.8843, 47.1619],
	  '801': [9.9317, 47.1422],
	  '802': [9.9485, 47.4105],
	  '803': [9.7428, 47.3885],
	  '804': [9.6687, 47.279],
	  '900': [16.3732, 48.2068],
	  '10101': [16.531, 47.8516],
	  '10201': [16.6768, 47.8023],
	  '10301': [16.7069, 47.9522],
	  '10302': [16.6372, 47.901],
	  '10303': [16.475, 47.82],
	  '10304': [16.4778, 47.8883],
	  '10305': [16.5433, 47.7564],
	  '10306': [16.4896, 47.9234],
	  '10307': [16.6899, 47.7593],
	  '10308': [16.4491, 47.8436],
	  '10309': [16.3729, 47.8633],
	  '10310': [16.6998, 47.8428],
	  '10311': [16.6244, 47.8295],
	  '10312': [16.6991, 47.915],
	  '10313': [16.6093, 47.7995],
	  '10314': [16.6232, 47.8594],
	  '10315': [16.557, 47.7778],
	  '10316': [16.4081, 47.8462],
	  '10317': [16.5644, 47.8125],
	  '10318': [16.4411, 47.9104],
	  '10319': [16.5018, 47.7999],
	  '10320': [16.5161, 47.9104],
	  '10321': [16.5459, 47.8916],
	  '10322': [16.4002, 47.8146],
	  '10323': [16.5126, 47.7669],
	  '10401': [16.1894, 47.1421],
	  '10402': [16.1259, 47.1649],
	  '10403': [16.4437, 47.0955],
	  '10404': [16.2585, 47.0799],
	  '10405': [16.3496, 47.0575],
	  '10406': [16.2975, 47.1689],
	  '10407': [16.4231, 47.0185],
	  '10408': [16.1857, 47.072],
	  '10409': [16.2496, 47.1797],
	  '10410': [16.2583, 47.0303],
	  '10411': [16.2059, 47.1948],
	  '10412': [16.1604, 47.189],
	  '10413': [16.2589, 47.1131],
	  '10414': [16.1617, 47.1616],
	  '10415': [16.1288, 47.2011],
	  '10416': [16.4147, 47.0558],
	  '10417': [16.3203, 47.1144],
	  '10418': [16.1084, 47.1918],
	  '10419': [16.096, 47.2122],
	  '10420': [16.3463, 47.0185],
	  '10421': [16.3046, 47.0163],
	  '10422': [16.3249, 47.0299],
	  '10423': [16.3108, 47.0038],
	  '10424': [16.1955, 47.1187],
	  '10425': [16.1622, 47.1153],
	  '10426': [16.4965, 47.1361],
	  '10427': [16.2318, 47.1405],
	  '10428': [16.4966, 47.059],
	  '10501': [16.12, 47.0988],
	  '10502': [16.2119, 47.0256],
	  '10503': [16.2541, 46.996],
	  '10504': [16.1398, 46.9553],
	  '10505': [16.0827, 46.8874],
	  '10506': [16.2256, 46.961],
	  '10507': [16.0316, 46.8658],
	  '10508': [16.143, 47.0315],
	  '10509': [16.1303, 46.9065],
	  '10510': [16.1903, 46.9556],
	  '10511': [16.1701, 47.0022],
	  '10512': [16.0462, 46.891],
	  '10601': [16.493, 47.7504],
	  '10602': [16.3245, 47.7091],
	  '10603': [16.4525, 47.7887],
	  '10604': [16.4709, 47.7019],
	  '10605': [16.3905, 47.6919],
	  '10606': [16.3886, 47.7364],
	  '10607': [16.2952, 47.7998],
	  '10608': [16.4265, 47.7575],
	  '10609': [16.3668, 47.7975],
	  '10610': [16.4299, 47.694],
	  '10611': [16.328, 47.7763],
	  '10612': [16.5321, 47.7215],
	  '10613': [16.3884, 47.6589],
	  '10614': [16.3939, 47.7734],
	  '10615': [16.3217, 47.7446],
	  '10616': [16.4844, 47.7758],
	  '10617': [16.5027, 47.7323],
	  '10618': [16.4518, 47.7693],
	  '10619': [16.4189, 47.7904],
	  '10701': [17.0245, 47.7998],
	  '10702': [16.8648, 47.767],
	  '10703': [16.7285, 47.9913],
	  '10704': [17.1086, 48.0046],
	  '10705': [16.9244, 47.8335],
	  '10706': [17.0034, 48.0237],
	  '10707': [16.9203, 47.9075],
	  '10708': [16.9804, 47.8618],
	  '10709': [16.7802, 47.7874],
	  '10710': [16.7894, 47.9478],
	  '10711': [17.0585, 48.093],
	  '10712': [16.9879, 47.9151],
	  '10713': [16.8365, 47.9513],
	  '10714': [17.0508, 47.9372],
	  '10715': [17.0321, 48.0524],
	  '10716': [16.9027, 47.7098],
	  '10717': [16.8698, 47.9922],
	  '10718': [16.7734, 47.8427],
	  '10719': [16.9268, 47.7855],
	  '10720': [16.9827, 47.7708],
	  '10721': [16.9539, 47.7329],
	  '10722': [16.8886, 47.9338],
	  '10723': [16.7508, 47.9635],
	  '10724': [16.9799, 47.963],
	  '10725': [16.9265, 48.0039],
	  '10726': [16.9448, 48.0348],
	  '10727': [16.9907, 48.0983],
	  '10801': [16.6363, 47.5869],
	  '10802': [16.3995, 47.5034],
	  '10803': [16.5667, 47.4713],
	  '10804': [16.567, 47.5311],
	  '10805': [16.5563, 47.5782],
	  '10806': [16.3859, 47.5352],
	  '10807': [16.3726, 47.5957],
	  '10808': [16.4269, 47.647],
	  '10809': [16.4104, 47.3846],
	  '10810': [16.6341, 47.4664],
	  '10811': [16.5468, 47.4299],
	  '10812': [16.3438, 47.566],
	  '10813': [16.5454, 47.6105],
	  '10814': [16.4362, 47.5309],
	  '10815': [16.656, 47.5353],
	  '10816': [16.5213, 47.4953],
	  '10817': [16.3381, 47.427],
	  '10818': [16.4159, 47.4625],
	  '10819': [16.5331, 47.5576],
	  '10820': [16.4776, 47.6314],
	  '10821': [16.4823, 47.4714],
	  '10822': [16.4818, 47.5221],
	  '10823': [16.4294, 47.5841],
	  '10824': [16.4967, 47.5889],
	  '10825': [16.4936, 47.5662],
	  '10826': [16.3712, 47.4602],
	  '10827': [16.3544, 47.5223],
	  '10828': [16.4942, 47.4388],
	  '10901': [16.2368, 47.3358],
	  '10902': [16.256, 47.4157],
	  '10903': [16.4365, 47.1692],
	  '10904': [16.0642, 47.3625],
	  '10905': [16.3273, 47.232],
	  '10906': [16.3881, 47.2284],
	  '10907': [16.155, 47.2556],
	  '10908': [16.3575, 47.1606],
	  '10909': [16.1689, 47.2143],
	  '10910': [16.0732, 47.3319],
	  '10911': [16.2308, 47.3709],
	  '10912': [16.1014, 47.2991],
	  '10913': [16.3859, 47.2955],
	  '10914': [16.3009, 47.2012],
	  '10915': [16.2125, 47.2246],
	  '10916': [16.1881, 47.3557],
	  '10917': [16.1943, 47.2849],
	  '10918': [16.1138, 47.3678],
	  '10919': [16.4415, 47.302],
	  '10920': [16.1379, 47.3384],
	  '10921': [16.2446, 47.2445],
	  '10922': [16.3851, 47.2581],
	  '10923': [16.2731, 47.3142],
	  '10924': [16.3399, 47.3729],
	  '10925': [16.2104, 47.2511],
	  '10926': [16.3413, 47.3167],
	  '10927': [16.1525, 47.394],
	  '10928': [16.1055, 47.247],
	  '10929': [16.0361, 47.3646],
	  '10930': [16.271, 47.2336],
	  '10931': [16.3687, 47.1966],
	  '10932': [16.4261, 47.2402],
	  '20101': [14.3003, 46.6302],
	  '20201': [13.8377, 46.6153],
	  '20302': [13.0739, 46.6758],
	  '20305': [13.3053, 46.6013],
	  '20306': [13.165, 46.6433],
	  '20307': [12.9697, 46.6516],
	  '20316': [13.5227, 46.5965],
	  '20320': [13.242, 46.6868],
	  '20321': [12.8015, 46.6951],
	  '20402': [14.4047, 46.582],
	  '20403': [14.212, 46.521],
	  '20405': [14.2903, 46.5154],
	  '20409': [14.4887, 46.6208],
	  '20412': [14.1529, 46.5799],
	  '20414': [14.245, 46.561],
	  '20415': [14.2151, 46.6276],
	  '20416': [14.1497, 46.5479],
	  '20417': [14.3358, 46.5641],
	  '20418': [14.375, 46.6949],
	  '20419': [14.1745, 46.6062],
	  '20421': [14.1855, 46.6653],
	  '20424': [14.1629, 46.6356],
	  '20425': [14.4826, 46.6675],
	  '20428': [14.4139, 46.525],
	  '20432': [14.0948, 46.5867],
	  '20435': [14.0841, 46.6507],
	  '20441': [14.3236, 46.4551],
	  '20442': [14.4298, 46.6947],
	  '20501': [14.4735, 46.87],
	  '20502': [14.5051, 46.7325],
	  '20503': [14.0394, 46.8752],
	  '20504': [14.5919, 46.7953],
	  '20505': [14.3318, 46.9922],
	  '20506': [14.1059, 46.9063],
	  '20508': [14.2797, 46.8573],
	  '20509': [14.5099, 46.9074],
	  '20511': [14.6029, 46.9421],
	  '20512': [14.4853, 46.8321],
	  '20513': [14.5846, 46.8657],
	  '20515': [14.2441, 46.7658],
	  '20518': [14.1635, 46.9911],
	  '20519': [14.4381, 46.9207],
	  '20520': [14.4071, 46.8572],
	  '20523': [14.4313, 46.7771],
	  '20527': [14.3607, 46.7474],
	  '20530': [14.3251, 46.9112],
	  '20531': [14.1998, 46.8687],
	  '20534': [14.3234, 46.8048],
	  '20601': [13.7965, 46.8221],
	  '20602': [13.4376, 46.7976],
	  '20603': [13.1433, 46.7699],
	  '20604': [13.0681, 46.723],
	  '20605': [12.8986, 46.9706],
	  '20607': [13.0465, 46.9747],
	  '20608': [13.5429, 46.8843],
	  '20609': [13.1883, 46.7266],
	  '20610': [12.8332, 47.0438],
	  '20611': [13.0215, 46.7574],
	  '20613': [13.3161, 46.7793],
	  '20616': [13.4362, 46.8366],
	  '20618': [13.2175, 47.0081],
	  '20619': [13.393, 47.0025],
	  '20620': [13.5938, 46.8173],
	  '20622': [12.9093, 46.9142],
	  '20624': [13.3389, 46.8528],
	  '20625': [12.9517, 46.7476],
	  '20627': [13.2, 46.9343],
	  '20630': [13.6982, 46.821],
	  '20631': [12.9684, 46.8437],
	  '20632': [13.607, 47.0245],
	  '20633': [13.2794, 46.8259],
	  '20634': [13.5167, 46.8278],
	  '20635': [13.564, 46.7751],
	  '20636': [13.0388, 46.9],
	  '20637': [13.2523, 46.7642],
	  '20638': [13.4799, 46.894],
	  '20639': [13.3759, 46.6964],
	  '20640': [12.8743, 46.8668],
	  '20642': [13.6413, 46.9318],
	  '20643': [13.3904, 46.8619],
	  '20644': [13.282, 46.8825],
	  '20701': [13.7594, 46.7268],
	  '20702': [13.7256, 46.5467],
	  '20703': [13.8999, 46.7301],
	  '20705': [13.6788, 46.6208],
	  '20707': [13.5398, 46.5639],
	  '20708': [13.7429, 46.7684],
	  '20710': [13.6341, 46.7479],
	  '20711': [13.9423, 46.5462],
	  '20712': [13.6988, 46.7301],
	  '20713': [13.601, 46.5584],
	  '20719': [13.6402, 46.5957],
	  '20720': [13.6404, 46.6727],
	  '20721': [14.0038, 46.5844],
	  '20722': [14.0427, 46.5272],
	  '20723': [13.5366, 46.7189],
	  '20724': [13.8602, 46.6776],
	  '20725': [14.0267, 46.6419],
	  '20726': [13.7632, 46.6613],
	  '20727': [13.9556, 46.6242],
	  '20801': [14.8156, 46.6019],
	  '20802': [14.6608, 46.7717],
	  '20803': [14.6677, 46.6009],
	  '20804': [14.5502, 46.4711],
	  '20805': [14.7751, 46.5302],
	  '20806': [14.5093, 46.5444],
	  '20807': [14.7022, 46.5482],
	  '20808': [14.7189, 46.7296],
	  '20810': [14.899, 46.6302],
	  '20812': [14.7581, 46.6559],
	  '20813': [14.5693, 46.5976],
	  '20815': [14.6312, 46.5403],
	  '20817': [14.5999, 46.6737],
	  '20901': [14.8286, 46.9611],
	  '20905': [14.9482, 46.8651],
	  '20909': [14.9744, 46.666],
	  '20911': [14.9334, 46.9591],
	  '20912': [14.6844, 46.991],
	  '20913': [14.8055, 46.7613],
	  '20914': [14.9654, 46.7526],
	  '20918': [14.8367, 46.7004],
	  '20923': [14.7405, 46.8692],
	  '21001': [14.0259, 46.8205],
	  '21002': [14.1126, 46.7095],
	  '21003': [14.2131, 46.7187],
	  '21004': [13.9331, 46.7952],
	  '21005': [14.0235, 46.7497],
	  '21006': [13.9989, 46.6745],
	  '21007': [13.8839, 46.8697],
	  '21008': [14.1578, 46.7529],
	  '21009': [13.9623, 46.6929],
	  '21010': [14.101, 46.7849],
	  '30101': [15.6028, 48.4212],
	  '30201': [15.6221, 48.2025],
	  '30301': [14.774, 47.9491],
	  '30401': [16.2405, 47.8149],
	  '30501': [14.8027, 48.0241],
	  '30502': [14.81, 48.0822],
	  '30503': [14.8275, 48.1656],
	  '30504': [14.73, 48.0747],
	  '30506': [14.4834, 48.0488],
	  '30507': [14.7154, 48.0274],
	  '30508': [14.4997, 48.21],
	  '30509': [14.4986, 48.1289],
	  '30510': [14.6353, 47.9695],
	  '30511': [14.9338, 48.0623],
	  '30512': [14.9824, 48.0925],
	  '30514': [14.568, 48.1053],
	  '30515': [14.4953, 48.0867],
	  '30516': [14.786, 47.7843],
	  '30517': [14.7678, 48.0459],
	  '30520': [14.8625, 48.0484],
	  '30521': [14.9153, 48.205],
	  '30522': [14.7489, 48.1098],
	  '30524': [14.8187, 47.8698],
	  '30526': [14.8967, 47.8496],
	  '30527': [14.9513, 48.1186],
	  '30529': [14.5682, 48.2063],
	  '30530': [14.5782, 47.9913],
	  '30531': [14.5403, 48.1725],
	  '30532': [14.6561, 48.0278],
	  '30533': [14.76, 48],
	  '30534': [14.66, 48.1429],
	  '30536': [14.905, 48.1506],
	  '30538': [14.7204, 48.1414],
	  '30539': [14.5742, 48.0579],
	  '30541': [14.8653, 48.0889],
	  '30542': [14.6689, 48.0768],
	  '30543': [14.8922, 47.9392],
	  '30544': [14.7853, 48.1248],
	  '30601': [16.0645, 48.0515],
	  '30602': [15.994, 48.0261],
	  '30603': [16.1838, 47.9631],
	  '30604': [16.22, 48.0056],
	  '30605': [16.1385, 47.9387],
	  '30607': [16.4124, 47.9659],
	  '30608': [16.1637, 47.9132],
	  '30609': [15.9656, 47.9701],
	  '30612': [16.2763, 47.9369],
	  '30613': [16.1324, 48.0482],
	  '30614': [16.0553, 47.9207],
	  '30615': [16.171, 47.9352],
	  '30616': [15.9959, 48.1073],
	  '30618': [16.2408, 47.953],
	  '30620': [16.2137, 47.9206],
	  '30621': [16.4775, 47.9864],
	  '30623': [16.3255, 47.9773],
	  '30625': [16.2425, 48.0267],
	  '30626': [16.3543, 47.9124],
	  '30627': [16.0823, 47.9619],
	  '30629': [16.5227, 47.9937],
	  '30631': [16.2584, 47.9246],
	  '30633': [16.5096, 47.9588],
	  '30635': [16.1852, 47.9903],
	  '30636': [16.3354, 47.9436],
	  '30637': [16.28, 47.958],
	  '30639': [16.3052, 48.0181],
	  '30641': [16.3602, 47.9951],
	  '30645': [16.0575, 48.0035],
	  '30646': [16.2971, 47.9225],
	  '30701': [16.57, 47.9112],
	  '30702': [16.9027, 48.1209],
	  '30703': [17.0494, 48.1131],
	  '30704': [16.7329, 48.0234],
	  '30706': [16.6258, 48.0758],
	  '30708': [16.7289, 48.0628],
	  '30709': [16.5515, 48.0253],
	  '30710': [16.9558, 48.1503],
	  '30711': [16.7047, 48.1053],
	  '30712': [16.7908, 48.0651],
	  '30713': [16.5631, 47.9509],
	  '30715': [16.9432, 48.1152],
	  '30716': [16.6123, 47.9609],
	  '30718': [16.8575, 48.1088],
	  '30719': [16.9556, 48.0729],
	  '30721': [16.8446, 48.0652],
	  '30722': [16.799, 48.1001],
	  '30724': [16.6592, 47.9899],
	  '30726': [16.6666, 48.0414],
	  '30728': [17.0091, 48.1293],
	  '30801': [16.5317, 48.276],
	  '30802': [16.6738, 48.1815],
	  '30803': [16.808, 48.3963],
	  '30804': [16.6436, 48.3712],
	  '30805': [16.5879, 48.4483],
	  '30808': [16.5622, 48.3077],
	  '30810': [16.9192, 48.54],
	  '30811': [16.8364, 48.4726],
	  '30812': [16.7785, 48.4302],
	  '30813': [16.7928, 48.1478],
	  '30814': [16.8943, 48.1786],
	  '30817': [16.7205, 48.34],
	  '30819': [16.6375, 48.2432],
	  '30821': [16.6076, 48.1876],
	  '30822': [16.6073, 48.2511],
	  '30824': [16.6262, 48.4096],
	  '30825': [16.7818, 48.1911],
	  '30826': [16.7283, 48.5916],
	  '30827': [16.8858, 48.6114],
	  '30828': [16.6754, 48.4532],
	  '30829': [16.8661, 48.5037],
	  '30830': [16.8093, 48.2355],
	  '30831': [16.7099, 48.2072],
	  '30834': [16.6636, 48.1521],
	  '30835': [16.8939, 48.2593],
	  '30836': [16.6357, 48.2846],
	  '30838': [16.691, 48.4057],
	  '30841': [16.778, 48.5977],
	  '30842': [16.7013, 48.2715],
	  '30844': [16.7116, 48.1432],
	  '30845': [16.8259, 48.5941],
	  '30846': [16.5899, 48.2729],
	  '30848': [16.7431, 48.3911],
	  '30849': [16.5674, 48.2499],
	  '30850': [16.8748, 48.5688],
	  '30852': [16.6908, 48.365],
	  '30854': [16.7411, 48.4526],
	  '30856': [16.6479, 48.3144],
	  '30857': [16.69, 48.492],
	  '30858': [16.7529, 48.257],
	  '30859': [16.7857, 48.4673],
	  '30860': [16.7795, 48.3571],
	  '30863': [16.754, 48.5351],
	  '30865': [16.8459, 48.31],
	  '30902': [15.0768, 48.8423],
	  '30903': [15.0051, 48.8611],
	  '30904': [15.1601, 48.9082],
	  '30906': [15.0995, 48.9153],
	  '30908': [14.9831, 48.7981],
	  '30909': [14.919, 48.7498],
	  '30910': [14.7602, 48.6105],
	  '30912': [14.9561, 48.6537],
	  '30913': [14.7655, 48.6847],
	  '30915': [15.0243, 48.9995],
	  '30916': [15.1198, 48.8609],
	  '30917': [15.1182, 48.7458],
	  '30920': [15.0418, 48.7642],
	  '30921': [15.0858, 48.7238],
	  '30925': [15.0313, 48.9466],
	  '30929': [15.1314, 48.9835],
	  '30932': [14.8323, 48.6686],
	  '30935': [15.0686, 48.8011],
	  '30939': [14.83, 48.7515],
	  '30940': [15.0126, 48.7202],
	  '30942': [14.9041, 48.6854],
	  '31001': [16.1053, 48.683],
	  '31008': [16.1414, 48.5062],
	  '31009': [16.0206, 48.6095],
	  '31014': [16.0261, 48.6581],
	  '31015': [16.1291, 48.7245],
	  '31016': [15.8589, 48.8221],
	  '31018': [16.0698, 48.7161],
	  '31019': [16.0074, 48.5117],
	  '31021': [15.7958, 48.5123],
	  '31022': [16.0641, 48.55],
	  '31025': [16.1677, 48.6675],
	  '31026': [15.7804, 48.5614],
	  '31028': [16.2203, 48.6255],
	  '31033': [16.0301, 48.6961],
	  '31035': [15.8597, 48.7067],
	  '31036': [15.8689, 48.5554],
	  '31037': [15.9669, 48.7412],
	  '31038': [16.0448, 48.7519],
	  '31041': [15.8913, 48.744],
	  '31042': [16.1913, 48.7238],
	  '31043': [15.9427, 48.6189],
	  '31051': [16.1097, 48.639],
	  '31052': [15.9681, 48.6869],
	  '31053': [15.9702, 48.5402],
	  '31101': [15.5686, 48.6436],
	  '31102': [15.4668, 48.7025],
	  '31103': [15.7717, 48.6097],
	  '31104': [15.6404, 48.8553],
	  '31105': [15.8143, 48.6503],
	  '31106': [15.671, 48.5912],
	  '31107': [15.6664, 48.785],
	  '31109': [15.6729, 48.6803],
	  '31110': [15.5381, 48.7346],
	  '31111': [15.5548, 48.8029],
	  '31113': [15.7128, 48.8405],
	  '31114': [15.7461, 48.659],
	  '31117': [15.6278, 48.7346],
	  '31119': [15.4678, 48.6616],
	  '31120': [15.8857, 48.6674],
	  '31121': [15.6965, 48.6354],
	  '31123': [15.5946, 48.6824],
	  '31124': [15.7269, 48.7103],
	  '31129': [15.7802, 48.7828],
	  '31130': [15.8594, 48.6225],
	  '31201': [16.3679, 48.3337],
	  '31202': [16.4248, 48.3617],
	  '31203': [16.3342, 48.5274],
	  '31204': [16.2309, 48.5188],
	  '31205': [16.3941, 48.4718],
	  '31206': [16.4438, 48.3425],
	  '31207': [16.3871, 48.4126],
	  '31208': [16.0973, 48.391],
	  '31213': [16.3249, 48.3491],
	  '31214': [16.3637, 48.3079],
	  '31215': [16.2468, 48.4259],
	  '31216': [16.3185, 48.3823],
	  '31224': [16.0497, 48.4585],
	  '31226': [16.1555, 48.4443],
	  '31227': [16.2655, 48.3718],
	  '31228': [16.0233, 48.3971],
	  '31229': [16.3808, 48.3659],
	  '31230': [16.2084, 48.3847],
	  '31234': [16.3023, 48.4578],
	  '31301': [15.3935, 48.3115],
	  '31302': [15.3641, 48.4517],
	  '31303': [15.4927, 48.3402],
	  '31304': [15.5363, 48.3973],
	  '31308': [15.7367, 48.4266],
	  '31309': [15.6118, 48.3781],
	  '31310': [15.6917, 48.402],
	  '31311': [15.5339, 48.5147],
	  '31315': [15.7136, 48.473],
	  '31319': [15.4653, 48.547],
	  '31321': [15.4654, 48.5887],
	  '31322': [15.6295, 48.5077],
	  '31323': [15.612, 48.4689],
	  '31324': [15.3768, 48.5023],
	  '31326': [15.3371, 48.308],
	  '31327': [15.5804, 48.3887],
	  '31330': [15.3164, 48.3693],
	  '31333': [15.644, 48.3534],
	  '31336': [15.3567, 48.5586],
	  '31337': [15.6631, 48.4218],
	  '31338': [15.4941, 48.379],
	  '31340': [15.5639, 48.5859],
	  '31343': [15.5169, 48.4546],
	  '31344': [15.3854, 48.3528],
	  '31346': [15.7462, 48.4904],
	  '31347': [15.61, 48.4484],
	  '31350': [15.4501, 48.4431],
	  '31351': [15.4402, 48.3941],
	  '31355': [15.6804, 48.5447],
	  '31356': [15.5455, 48.4767],
	  '31401': [15.3825, 47.8678],
	  '31402': [15.5581, 48.0463],
	  '31403': [15.8074, 48.0386],
	  '31404': [15.6141, 47.9172],
	  '31405': [15.9041, 48.0202],
	  '31406': [15.7289, 47.9625],
	  '31407': [15.5879, 48.0123],
	  '31408': [15.238, 47.8407],
	  '31409': [15.826, 47.9818],
	  '31410': [15.7513, 48.0637],
	  '31411': [15.5293, 47.8152],
	  '31412': [15.6727, 48.0437],
	  '31413': [15.6098, 48.0433],
	  '31414': [15.4909, 47.9116],
	  '31502': [15.1997, 48.2597],
	  '31503': [15.1926, 48.1511],
	  '31504': [15.4643, 48.1232],
	  '31505': [14.994, 48.1292],
	  '31506': [14.9868, 48.3457],
	  '31507': [15.4267, 48.2461],
	  '31508': [15.1944, 48.1831],
	  '31509': [15.1717, 48.193],
	  '31511': [15.0674, 48.2199],
	  '31513': [15.4031, 48.1514],
	  '31514': [15.4061, 48.1061],
	  '31515': [15.3059, 48.0713],
	  '31516': [15.2072, 48.222],
	  '31517': [15.148, 48.201],
	  '31519': [15.2673, 48.2355],
	  '31520': [15.4086, 48.2003],
	  '31521': [15.333, 48.105],
	  '31522': [15.129, 48.2186],
	  '31523': [15.1446, 48.2343],
	  '31524': [15.3296, 48.2136],
	  '31525': [15.1169, 48.2633],
	  '31527': [15.0825, 48.1468],
	  '31528': [14.992, 48.2221],
	  '31530': [15.1003, 48.1835],
	  '31531': [15.1535, 48.1451],
	  '31533': [15.2271, 48.201],
	  '31534': [15.1764, 48.3045],
	  '31535': [15.2704, 48.338],
	  '31537': [15.2417, 48.1271],
	  '31539': [15.2957, 48.161],
	  '31540': [15.0246, 48.1574],
	  '31541': [15.0198, 48.2664],
	  '31542': [15.4217, 48.2807],
	  '31543': [15.3634, 48.1888],
	  '31546': [15.2611, 48.2889],
	  '31549': [15.069, 48.1717],
	  '31550': [15.2434, 48.1772],
	  '31551': [15.3291, 48.0426],
	  '31552': [15.0699, 48.2914],
	  '31553': [15.3289, 48.2546],
	  '31601': [16.7958, 48.6547],
	  '31603': [16.4871, 48.586],
	  '31604': [16.8644, 48.6898],
	  '31605': [16.6074, 48.3634],
	  '31606': [16.6409, 48.7591],
	  '31608': [16.5859, 48.7131],
	  '31609': [16.4342, 48.6447],
	  '31611': [16.3762, 48.6505],
	  '31612': [16.5855, 48.495],
	  '31613': [16.3831, 48.6103],
	  '31614': [16.4706, 48.3629],
	  '31615': [16.573, 48.3468],
	  '31616': [16.2454, 48.6886],
	  '31617': [16.7323, 48.6679],
	  '31620': [16.8314, 48.625],
	  '31621': [16.7113, 48.6957],
	  '31622': [16.5292, 48.4457],
	  '31627': [16.4821, 48.4493],
	  '31628': [16.4761, 48.4805],
	  '31629': [16.4092, 48.717],
	  '31630': [16.4916, 48.5273],
	  '31633': [16.5682, 48.5617],
	  '31634': [16.4898, 48.7255],
	  '31636': [16.4078, 48.5539],
	  '31642': [16.539, 48.3539],
	  '31644': [16.6279, 48.6597],
	  '31645': [16.8872, 48.6521],
	  '31646': [16.7149, 48.723],
	  '31649': [16.488, 48.6771],
	  '31650': [16.3019, 48.6463],
	  '31651': [16.4794, 48.413],
	  '31652': [16.3416, 48.6829],
	  '31653': [16.4984, 48.7742],
	  '31654': [16.6658, 48.5948],
	  '31655': [16.5336, 48.3912],
	  '31658': [16.5746, 48.7808],
	  '31701': [16.3835, 48.0844],
	  '31702': [16.3476, 48.0922],
	  '31703': [16.1495, 48.1367],
	  '31704': [16.299, 48.1094],
	  '31706': [16.2218, 48.0512],
	  '31707': [16.2265, 48.0932],
	  '31709': [16.2808, 48.0459],
	  '31710': [16.3245, 48.048],
	  '31711': [16.3732, 48.1174],
	  '31712': [16.1994, 48.0801],
	  '31713': [16.1767, 48.1066],
	  '31714': [16.1726, 48.1586],
	  '31715': [16.3593, 48.0589],
	  '31716': [16.272, 48.0953],
	  '31717': [16.289, 48.0763],
	  '31718': [16.388, 48.0254],
	  '31719': [16.2498, 48.1193],
	  '31723': [16.3379, 48.1213],
	  '31725': [16.3195, 48.0804],
	  '31726': [16.1028, 48.1044],
	  '31801': [16.0144, 47.6577],
	  '31802': [16.0915, 47.5488],
	  '31803': [15.9883, 47.5399],
	  '31804': [16.1365, 47.7397],
	  '31805': [15.7998, 47.6588],
	  '31806': [15.9813, 47.6947],
	  '31807': [16.1631, 47.5917],
	  '31808': [15.9842, 47.6691],
	  '31809': [16.0612, 47.6061],
	  '31810': [15.8976, 47.6594],
	  '31811': [16.0259, 47.6825],
	  '31812': [16.1043, 47.6231],
	  '31813': [15.9891, 47.8032],
	  '31814': [15.9443, 47.5975],
	  '31815': [16.0483, 47.5134],
	  '31817': [16.1137, 47.7102],
	  '31818': [16.0978, 47.7333],
	  '31820': [15.9329, 47.6248],
	  '31821': [15.8722, 47.6822],
	  '31823': [16.1981, 47.7029],
	  '31825': [15.9242, 47.6999],
	  '31826': [15.89, 47.7803],
	  '31827': [15.9521, 47.6446],
	  '31829': [15.7878, 47.7048],
	  '31830': [15.9929, 47.576],
	  '31831': [16.1172, 47.7814],
	  '31832': [16.1694, 47.6608],
	  '31833': [15.8635, 47.6362],
	  '31834': [15.9883, 47.7793],
	  '31835': [16.1794, 47.7375],
	  '31836': [15.6972, 47.7879],
	  '31837': [16.1473, 47.6929],
	  '31838': [15.8299, 47.6465],
	  '31839': [16.0259, 47.7334],
	  '31840': [16.145, 47.5681],
	  '31841': [15.8828, 47.5928],
	  '31842': [15.8764, 47.7269],
	  '31843': [16.0558, 47.6385],
	  '31844': [16.0764, 47.6872],
	  '31845': [16.057, 47.7948],
	  '31846': [16.036, 47.6999],
	  '31847': [16.0578, 47.7712],
	  '31848': [16.1345, 47.5257],
	  '31849': [16.0258, 47.7947],
	  '31901': [15.9423, 48.1421],
	  '31902': [15.9158, 48.2465],
	  '31903': [15.7635, 48.2007],
	  '31904': [15.8782, 48.0978],
	  '31905': [15.9761, 48.167],
	  '31906': [15.3216, 47.9829],
	  '31907': [15.557, 48.2014],
	  '31909': [15.5204, 48.0858],
	  '31910': [15.4776, 48.2248],
	  '31911': [15.4567, 48.1944],
	  '31912': [15.7381, 48.2984],
	  '31913': [15.6932, 48.3166],
	  '31915': [15.7631, 48.2637],
	  '31916': [15.5201, 48.2694],
	  '31917': [15.7809, 48.151],
	  '31918': [15.4701, 48.0048],
	  '31919': [15.818, 48.2068],
	  '31920': [15.4102, 47.9847],
	  '31921': [15.9428, 48.1876],
	  '31922': [15.5039, 48.1843],
	  '31923': [15.7528, 48.0965],
	  '31925': [15.5267, 48.2421],
	  '31926': [15.8796, 48.2078],
	  '31927': [15.8928, 48.136],
	  '31928': [15.6912, 48.347],
	  '31929': [15.552, 48.1448],
	  '31930': [15.6236, 48.275],
	  '31932': [15.5214, 48.1995],
	  '31934': [15.6993, 48.1421],
	  '31935': [15.4805, 48.0502],
	  '31938': [15.4945, 48.1555],
	  '31939': [15.3638, 47.9296],
	  '31940': [15.6485, 48.3269],
	  '31941': [15.8056, 48.1161],
	  '31943': [15.7618, 48.3518],
	  '31945': [15.5227, 48.1178],
	  '31946': [15.8081, 48.2702],
	  '31947': [15.6068, 48.0967],
	  '31948': [15.56, 48.3179],
	  '32001': [15.1047, 47.9083],
	  '32002': [14.9356, 47.776],
	  '32003': [15.0237, 47.9744],
	  '32004': [14.9901, 47.9532],
	  '32005': [15.0034, 47.8615],
	  '32006': [15.224, 48.068],
	  '32007': [15.2842, 47.9081],
	  '32008': [15.1359, 48.0605],
	  '32009': [14.951, 48.0115],
	  '32010': [15.0833, 47.9884],
	  '32011': [15.2232, 47.957],
	  '32012': [15.2329, 48.0229],
	  '32013': [15.1464, 47.9976],
	  '32014': [15.0277, 48.0742],
	  '32015': [14.9866, 48.0533],
	  '32016': [15.1462, 48.1276],
	  '32017': [15.1048, 48.1189],
	  '32018': [15.0789, 48.0902],
	  '32101': [15.9759, 48.3961],
	  '32104': [15.8798, 48.3031],
	  '32106': [15.8296, 48.4462],
	  '32107': [15.7914, 48.4054],
	  '32109': [15.883, 48.4803],
	  '32110': [15.9762, 48.4637],
	  '32112': [16.0202, 48.2857],
	  '32114': [15.9003, 48.4264],
	  '32115': [15.9337, 48.3901],
	  '32116': [16.1619, 48.2946],
	  '32119': [15.9987, 48.3226],
	  '32120': [15.9515, 48.2934],
	  '32131': [16.0053, 48.2473],
	  '32132': [15.8292, 48.322],
	  '32134': [16.1176, 48.2813],
	  '32135': [16.0753, 48.3248],
	  '32139': [15.8585, 48.2617],
	  '32140': [16.1783, 48.3239],
	  '32141': [15.9056, 48.3452],
	  '32142': [16.2119, 48.3373],
	  '32143': [16.1526, 48.3345],
	  '32202': [15.3641, 48.7985],
	  '32203': [15.3177, 48.9107],
	  '32206': [15.2124, 48.8897],
	  '32207': [15.4223, 48.7914],
	  '32209': [15.3725, 48.8802],
	  '32210': [15.2416, 48.9351],
	  '32212': [15.485, 48.7917],
	  '32214': [15.1932, 48.8508],
	  '32216': [15.5294, 48.8687],
	  '32217': [15.2885, 48.8647],
	  '32219': [15.1754, 48.7662],
	  '32220': [15.322, 48.8129],
	  '32221': [15.2224, 48.8158],
	  '32222': [15.363, 48.9522],
	  '32223': [15.3004, 48.7687],
	  '32301': [16.1629, 47.8312],
	  '32302': [16.2464, 47.4924],
	  '32304': [16.3211, 47.8903],
	  '32305': [16.299, 47.8655],
	  '32306': [16.2118, 47.7252],
	  '32307': [16.2413, 47.8793],
	  '32308': [15.8563, 47.8669],
	  '32309': [16.2015, 47.4465],
	  '32310': [16.2987, 47.6696],
	  '32311': [16.061, 47.8251],
	  '32312': [16.2688, 47.573],
	  '32313': [16.2771, 47.7781],
	  '32314': [16.2917, 47.5193],
	  '32315': [16.1986, 47.5105],
	  '32316': [16.2413, 47.7541],
	  '32317': [16.2177, 47.5663],
	  '32318': [16.3113, 47.8255],
	  '32319': [16.1165, 47.8603],
	  '32320': [16.1937, 47.891],
	  '32321': [15.9759, 47.844],
	  '32322': [15.9031, 47.9264],
	  '32323': [15.9882, 47.9029],
	  '32324': [15.7458, 47.8887],
	  '32325': [16.2354, 47.6517],
	  '32326': [16.3463, 47.6425],
	  '32327': [16.2469, 47.9015],
	  '32330': [16.2475, 47.8595],
	  '32331': [15.9457, 47.8734],
	  '32332': [16.0401, 47.8727],
	  '32333': [16.253, 47.7006],
	  '32334': [16.1722, 47.7952],
	  '32335': [16.2928, 47.6131],
	  '32336': [16.1105, 47.8343],
	  '32337': [16.1867, 47.8611],
	  '32338': [16.3498, 47.8467],
	  '32401': [16.5156, 48.0547],
	  '32402': [16.5993, 48.1214],
	  '32403': [16.1327, 48.2308],
	  '32404': [16.4796, 48.315],
	  '32405': [16.4937, 48.028],
	  '32406': [16.4463, 48.0696],
	  '32407': [16.5986, 48.0958],
	  '32408': [16.3026, 48.3049],
	  '32409': [16.4309, 48.1116],
	  '32410': [16.3987, 48.1084],
	  '32411': [16.4145, 48.096],
	  '32412': [16.1715, 48.2509],
	  '32413': [16.4479, 48.0101],
	  '32415': [16.0504, 48.1724],
	  '32416': [16.1705, 48.1952],
	  '32417': [16.5222, 48.0891],
	  '32418': [16.5706, 48.0807],
	  '32419': [16.5078, 48.134],
	  '32421': [16.094, 48.2117],
	  '32423': [16.1094, 48.151],
	  '32424': [16.4783, 48.1087],
	  '32501': [15.3301, 48.6824],
	  '32502': [14.9189, 48.479],
	  '32503': [15.0114, 48.4018],
	  '32504': [15.2238, 48.7141],
	  '32505': [15.3859, 48.7365],
	  '32506': [15.1481, 48.4962],
	  '32508': [14.9728, 48.5808],
	  '32509': [15.189, 48.544],
	  '32511': [15.0904, 48.3875],
	  '32514': [15.2238, 48.3879],
	  '32515': [15.2915, 48.4211],
	  '32516': [14.8615, 48.57],
	  '32517': [15.1497, 48.3869],
	  '32518': [15.1934, 48.4313],
	  '32519': [14.969, 48.4469],
	  '32520': [15.4039, 48.6373],
	  '32521': [15.0571, 48.5088],
	  '32522': [15.2431, 48.4709],
	  '32523': [15.0415, 48.4604],
	  '32524': [15.2758, 48.7308],
	  '32525': [15.0731, 48.6715],
	  '32528': [15.104, 48.4266],
	  '32529': [15.2895, 48.5424],
	  '32530': [15.1725, 48.6223],
	  '40101': [14.3232, 48.2569],
	  '40201': [14.4172, 48.0516],
	  '40301': [14.0257, 48.1787],
	  '40401': [13.239, 48.2476],
	  '40402': [13.3138, 48.1984],
	  '40403': [13.0994, 48.0721],
	  '40404': [13.0484, 48.2492],
	  '40405': [13.0895, 48.2027],
	  '40406': [12.987, 48.0843],
	  '40407': [13.0481, 48.0645],
	  '40408': [12.9296, 48.0495],
	  '40409': [12.9092, 48.0942],
	  '40410': [12.93, 48.1379],
	  '40411': [12.8852, 48.0365],
	  '40412': [12.9904, 48.1478],
	  '40413': [13.1272, 48.1618],
	  '40414': [12.8542, 48.1393],
	  '40415': [13.2638, 48.1675],
	  '40416': [13.1481, 48.0481],
	  '40417': [13.0953, 48.0413],
	  '40418': [13.2455, 48.0199],
	  '40419': [13.1698, 48.0046],
	  '40420': [13.2185, 48.1335],
	  '40421': [13.1481, 48.0992],
	  '40422': [13.1333, 48.186],
	  '40423': [13.1757, 48.2767],
	  '40424': [13.169, 48.2094],
	  '40425': [12.9798, 48.0411],
	  '40426': [13.2136, 48.0673],
	  '40427': [13.0279, 48.185],
	  '40428': [12.8199, 48.051],
	  '40429': [13.1218, 48.0158],
	  '40430': [13.0982, 48.0029],
	  '40431': [13.1381, 48.0754],
	  '40432': [13.0813, 48.1285],
	  '40433': [13.2887, 48.2323],
	  '40434': [13.2382, 48.1927],
	  '40435': [13.0167, 48.1218],
	  '40436': [13.2949, 48.1127],
	  '40437': [12.8775, 48.0113],
	  '40438': [13.1018, 48.26],
	  '40439': [12.779, 48.1067],
	  '40440': [13.273, 48.2105],
	  '40441': [13.1925, 48.0976],
	  '40442': [12.9628, 48.1816],
	  '40443': [12.828, 48.0827],
	  '40444': [13.1912, 48.1861],
	  '40445': [12.8984, 48.1839],
	  '40446': [13.1831, 48.2441],
	  '40501': [14.1006, 48.2859],
	  '40502': [14.0171, 48.3642],
	  '40503': [14.0227, 48.304],
	  '40504': [14.013, 48.2839],
	  '40505': [13.8999, 48.4247],
	  '40506': [13.9763, 48.386],
	  '40507': [13.9852, 48.2996],
	  '40508': [13.9167, 48.3086],
	  '40509': [14.0425, 48.3159],
	  '40510': [13.9417, 48.2693],
	  '40511': [14.0228, 48.2606],
	  '40512': [13.9219, 48.3589],
	  '40601': [14.4919, 48.499],
	  '40602': [14.5357, 48.5388],
	  '40603': [14.6027, 48.4191],
	  '40604': [14.5125, 48.3778],
	  '40605': [14.4236, 48.4814],
	  '40606': [14.7766, 48.475],
	  '40607': [14.5081, 48.4471],
	  '40608': [14.8378, 48.4024],
	  '40609': [14.5432, 48.4771],
	  '40610': [14.4742, 48.6158],
	  '40611': [14.7897, 48.5272],
	  '40612': [14.4523, 48.441],
	  '40613': [14.7535, 48.3564],
	  '40614': [14.549, 48.3486],
	  '40615': [14.4521, 48.5665],
	  '40616': [14.6618, 48.5529],
	  '40617': [14.6827, 48.4499],
	  '40618': [14.6124, 48.5006],
	  '40619': [14.7243, 48.4047],
	  '40620': [14.6015, 48.3322],
	  '40621': [14.8171, 48.4524],
	  '40622': [14.4638, 48.3652],
	  '40623': [14.4388, 48.5144],
	  '40624': [14.4958, 48.343],
	  '40625': [14.7104, 48.5],
	  '40626': [14.575, 48.5802],
	  '40627': [14.6772, 48.3507],
	  '40701': [13.7178, 47.8833],
	  '40702': [13.6466, 47.6295],
	  '40703': [13.6306, 47.7252],
	  '40704': [13.792, 47.7701],
	  '40705': [13.8229, 47.889],
	  '40706': [13.5511, 47.5839],
	  '40707': [13.9622, 47.7515],
	  '40708': [13.8477, 47.9317],
	  '40709': [13.609, 47.53],
	  '40710': [13.9074, 47.9499],
	  '40711': [13.8423, 47.9827],
	  '40712': [13.706, 47.516],
	  '40713': [13.777, 47.9649],
	  '40714': [13.7435, 47.9318],
	  '40715': [13.8438, 48.0239],
	  '40716': [13.8913, 47.9102],
	  '40717': [13.4912, 47.7497],
	  '40718': [13.7789, 47.8451],
	  '40719': [13.9498, 47.9084],
	  '40720': [13.9328, 48.0023],
	  '40801': [13.7417, 48.1863],
	  '40802': [13.9138, 48.2398],
	  '40803': [13.7658, 48.3121],
	  '40804': [13.7994, 48.3915],
	  '40805': [13.8075, 48.2055],
	  '40806': [13.7365, 48.1452],
	  '40807': [13.6394, 48.1452],
	  '40808': [13.8154, 48.2276],
	  '40809': [13.6394, 48.1886],
	  '40810': [13.8207, 48.3565],
	  '40811': [13.7302, 48.2152],
	  '40812': [13.6926, 48.2852],
	  '40813': [13.8466, 48.1786],
	  '40814': [13.7971, 48.1736],
	  '40815': [13.8196, 48.2851],
	  '40816': [13.7277, 48.3999],
	  '40817': [13.7736, 48.416],
	  '40818': [13.7324, 48.2728],
	  '40819': [13.7632, 48.3622],
	  '40820': [13.7663, 48.2832],
	  '40821': [13.8675, 48.2601],
	  '40822': [13.6105, 48.2271],
	  '40823': [13.6722, 48.2114],
	  '40824': [13.8691, 48.3847],
	  '40825': [13.7803, 48.2291],
	  '40826': [13.8917, 48.2875],
	  '40827': [13.874, 48.2247],
	  '40828': [13.7402, 48.3401],
	  '40829': [13.7327, 48.2493],
	  '40830': [13.8121, 48.2531],
	  '40831': [13.847, 48.3263],
	  '40832': [13.9496, 48.2348],
	  '40833': [13.6887, 48.1756],
	  '40834': [13.6733, 48.2493],
	  '40901': [14.3631, 47.7077],
	  '40902': [14.2221, 47.9324],
	  '40903': [14.1231, 47.6828],
	  '40904': [14.0752, 47.9329],
	  '40905': [14.1219, 47.9017],
	  '40906': [14.0898, 47.7866],
	  '40907': [14.1204, 48.0595],
	  '40908': [14.1228, 47.8685],
	  '40909': [14.3073, 47.8522],
	  '40910': [14.1635, 47.9714],
	  '40911': [14.1633, 47.9288],
	  '40912': [14.0244, 47.9569],
	  '40913': [14.066, 48.0276],
	  '40914': [14.4218, 47.7397],
	  '40915': [14.2988, 47.7557],
	  '40916': [14.213, 47.7776],
	  '40917': [14.1132, 47.9228],
	  '40918': [14.3315, 47.6577],
	  '40919': [14.0241, 47.894],
	  '40920': [14.2824, 47.9609],
	  '40921': [14.2353, 47.7015],
	  '40922': [14.0949, 47.9917],
	  '40923': [14.3282, 47.721],
	  '41001': [14.1806, 48.1641],
	  '41002': [14.2847, 48.2054],
	  '41003': [14.4088, 48.2359],
	  '41004': [14.1451, 48.1326],
	  '41005': [14.4594, 48.2181],
	  '41006': [14.4242, 48.1483],
	  '41007': [14.1769, 48.2091],
	  '41008': [14.3754, 48.1399],
	  '41009': [14.1786, 48.0882],
	  '41010': [14.1579, 48.2619],
	  '41011': [14.4498, 48.1223],
	  '41012': [14.2471, 48.2701],
	  '41013': [14.3719, 48.2051],
	  '41014': [14.221, 48.1434],
	  '41015': [14.3314, 48.1637],
	  '41016': [14.1397, 48.2332],
	  '41017': [14.2013, 48.2586],
	  '41018': [14.2245, 48.1036],
	  '41019': [14.2109, 48.1844],
	  '41020': [14.2948, 48.1349],
	  '41021': [14.2238, 48.2188],
	  '41022': [14.1811, 48.3022],
	  '41101': [14.6389, 48.2925],
	  '41102': [14.7121, 48.2336],
	  '41103': [14.7478, 48.217],
	  '41104': [14.896, 48.2982],
	  '41105': [14.8393, 48.2298],
	  '41106': [14.4978, 48.3044],
	  '41107': [14.7886, 48.2257],
	  '41108': [14.8306, 48.2755],
	  '41109': [14.4691, 48.2523],
	  '41110': [14.4247, 48.2586],
	  '41111': [14.525, 48.2486],
	  '41112': [14.6977, 48.1934],
	  '41113': [14.731, 48.266],
	  '41114': [14.6407, 48.205],
	  '41115': [14.8315, 48.325],
	  '41116': [14.6602, 48.2439],
	  '41117': [14.7043, 48.3117],
	  '41118': [14.5389, 48.3031],
	  '41119': [14.9171, 48.3648],
	  '41120': [14.4551, 48.2894],
	  '41121': [14.9045, 48.2432],
	  '41122': [14.7593, 48.3125],
	  '41123': [14.8098, 48.2044],
	  '41124': [14.5905, 48.2817],
	  '41125': [14.9538, 48.2673],
	  '41126': [14.6794, 48.2814],
	  '41201': [13.5256, 48.2614],
	  '41202': [13.4072, 48.3468],
	  '41203': [13.4656, 48.2393],
	  '41204': [13.5643, 48.1471],
	  '41205': [13.4222, 48.2403],
	  '41206': [13.5934, 48.2061],
	  '41207': [13.293, 48.2625],
	  '41208': [13.342, 48.2456],
	  '41209': [13.5318, 48.2002],
	  '41210': [13.2825, 48.2873],
	  '41211': [13.3708, 48.2066],
	  '41212': [13.5267, 48.3136],
	  '41213': [13.3493, 48.0946],
	  '41214': [13.4247, 48.2034],
	  '41215': [13.3562, 48.177],
	  '41216': [13.3698, 48.305],
	  '41217': [13.2202, 48.2823],
	  '41218': [13.4608, 48.1864],
	  '41219': [13.3321, 48.3193],
	  '41220': [13.4446, 48.3121],
	  '41221': [13.4864, 48.1617],
	  '41222': [13.5545, 48.2328],
	  '41223': [13.5021, 48.1279],
	  '41224': [13.3995, 48.3191],
	  '41225': [13.4845, 48.2099],
	  '41226': [13.3322, 48.2852],
	  '41227': [13.5786, 48.1879],
	  '41228': [13.428, 48.2969],
	  '41229': [13.4662, 48.1432],
	  '41230': [13.4152, 48.2667],
	  '41231': [13.5869, 48.2783],
	  '41232': [13.5044, 48.2317],
	  '41233': [13.4757, 48.2767],
	  '41234': [13.4155, 48.1151],
	  '41235': [13.3729, 48.274],
	  '41236': [13.3822, 48.2241],
	  '41301': [14.1451, 48.5806],
	  '41302': [14.1776, 48.5207],
	  '41303': [13.9879, 48.6673],
	  '41304': [13.954, 48.4787],
	  '41305': [13.9919, 48.5251],
	  '41306': [13.8653, 48.5426],
	  '41307': [14.0574, 48.5282],
	  '41308': [13.9955, 48.5953],
	  '41309': [14.0494, 48.5607],
	  '41310': [14.1297, 48.5489],
	  '41311': [13.9117, 48.5206],
	  '41312': [13.8194, 48.4738],
	  '41313': [13.846, 48.6636],
	  '41314': [13.9514, 48.435],
	  '41315': [13.8805, 48.7124],
	  '41316': [13.9975, 48.459],
	  '41317': [13.8455, 48.6002],
	  '41318': [13.9186, 48.4909],
	  '41319': [14.0685, 48.5919],
	  '41320': [13.842, 48.6293],
	  '41321': [14.0243, 48.4973],
	  '41322': [13.8887, 48.4688],
	  '41323': [14.0767, 48.4422],
	  '41324': [13.829, 48.5715],
	  '41325': [13.9415, 48.594],
	  '41326': [13.894, 48.6138],
	  '41327': [13.8002, 48.5358],
	  '41328': [13.8667, 48.5096],
	  '41329': [13.7529, 48.516],
	  '41330': [13.9809, 48.5711],
	  '41331': [14.1273, 48.4865],
	  '41332': [14.0317, 48.416],
	  '41333': [14.0256, 48.6191],
	  '41334': [14.0964, 48.5158],
	  '41335': [14.0919, 48.5682],
	  '41336': [14.0694, 48.4799],
	  '41337': [14.1593, 48.4646],
	  '41338': [13.9022, 48.5691],
	  '41339': [14.0262, 48.6662],
	  '41340': [14.1812, 48.5836],
	  '41341': [13.8518, 48.7477],
	  '41342': [13.9309, 48.6804],
	  '41401': [13.6919, 48.3222],
	  '41402': [13.5647, 48.3564],
	  '41403': [13.4838, 48.4792],
	  '41404': [13.5941, 48.424],
	  '41405': [13.633, 48.2632],
	  '41406': [13.5098, 48.3677],
	  '41407': [13.6969, 48.5042],
	  '41408': [13.6537, 48.3935],
	  '41409': [13.5942, 48.537],
	  '41410': [13.5197, 48.5597],
	  '41411': [13.6644, 48.4595],
	  '41412': [13.5125, 48.3472],
	  '41413': [13.5805, 48.4747],
	  '41414': [13.6469, 48.3537],
	  '41415': [13.5383, 48.4557],
	  '41416': [13.6519, 48.2964],
	  '41417': [13.7311, 48.468],
	  '41418': [13.4814, 48.4177],
	  '41419': [13.4436, 48.3791],
	  '41420': [13.6239, 48.4948],
	  '41421': [13.7018, 48.3668],
	  '41422': [13.4366, 48.4579],
	  '41423': [13.5146, 48.5254],
	  '41424': [13.6093, 48.3938],
	  '41425': [13.443, 48.4114],
	  '41426': [13.5302, 48.4121],
	  '41427': [13.66, 48.5235],
	  '41428': [13.8049, 48.4398],
	  '41429': [13.4782, 48.5042],
	  '41430': [13.6151, 48.3225],
	  '41501': [14.2117, 47.9919],
	  '41502': [14.3223, 47.9923],
	  '41503': [14.2167, 48.0429],
	  '41504': [14.4202, 48.092],
	  '41505': [14.7107, 47.8941],
	  '41506': [14.4162, 47.979],
	  '41507': [14.5393, 47.8585],
	  '41508': [14.5017, 47.9381],
	  '41509': [14.4118, 47.9232],
	  '41510': [14.6215, 47.9225],
	  '41511': [14.187, 48.0252],
	  '41512': [14.4443, 47.8316],
	  '41513': [14.2132, 48.0674],
	  '41514': [14.4499, 48.0202],
	  '41515': [14.2777, 48.0833],
	  '41516': [14.3082, 48.034],
	  '41517': [14.3513, 47.9418],
	  '41518': [14.2646, 48.0098],
	  '41521': [14.3622, 48.1099],
	  '41522': [14.6371, 47.803],
	  '41601': [14.4139, 48.3926],
	  '41602': [14.3415, 48.3749],
	  '41603': [14.297, 48.5185],
	  '41604': [14.2283, 48.3947],
	  '41605': [14.4341, 48.325],
	  '41606': [14.0618, 48.3557],
	  '41607': [14.4205, 48.3562],
	  '41608': [14.1005, 48.3245],
	  '41609': [14.1706, 48.3964],
	  '41610': [14.3655, 48.4375],
	  '41611': [14.3215, 48.4164],
	  '41612': [14.117, 48.4229],
	  '41613': [14.2767, 48.4131],
	  '41614': [14.2573, 48.3639],
	  '41615': [14.2086, 48.4739],
	  '41616': [14.3867, 48.4642],
	  '41617': [14.2044, 48.3354],
	  '41618': [14.2316, 48.3189],
	  '41619': [14.3357, 48.4756],
	  '41620': [14.379, 48.5531],
	  '41621': [14.1175, 48.3893],
	  '41622': [14.3553, 48.4965],
	  '41623': [14.2969, 48.4629],
	  '41624': [14.3744, 48.301],
	  '41625': [14.2278, 48.5503],
	  '41626': [14.1424, 48.3544],
	  '41627': [14.2601, 48.4649],
	  '41701': [13.5539, 48.0974],
	  '41702': [13.5262, 47.9071],
	  '41703': [13.7136, 48.0113],
	  '41704': [13.6996, 48.0749],
	  '41705': [13.673, 47.947],
	  '41706': [13.5084, 47.9576],
	  '41707': [13.7749, 48.0173],
	  '41708': [13.4155, 48.0273],
	  '41709': [13.4749, 48.0584],
	  '41710': [13.4161, 47.9888],
	  '41711': [13.5566, 47.9991],
	  '41712': [13.4187, 47.8369],
	  '41713': [13.6218, 47.9674],
	  '41714': [13.6652, 48.0675],
	  '41715': [13.3784, 47.8216],
	  '41716': [13.5379, 48.0432],
	  '41717': [13.7551, 48.0974],
	  '41718': [13.5125, 47.8661],
	  '41719': [13.3022, 47.9457],
	  '41720': [13.7622, 48.0694],
	  '41721': [13.4143, 47.8733],
	  '41722': [13.6308, 48.1078],
	  '41723': [13.4655, 48.0183],
	  '41724': [13.6685, 48.0325],
	  '41725': [13.733, 48.0662],
	  '41726': [13.3499, 48.0093],
	  '41727': [13.5792, 48.0432],
	  '41728': [13.7088, 48.037],
	  '41729': [13.4493, 48.0902],
	  '41730': [13.7526, 48.0389],
	  '41731': [13.7131, 47.9743],
	  '41732': [13.8045, 48.0442],
	  '41733': [13.7094, 48.0552],
	  '41734': [13.478, 47.93],
	  '41735': [13.3354, 47.828],
	  '41736': [13.7923, 48.0736],
	  '41737': [13.6209, 47.9338],
	  '41738': [13.7762, 48.0519],
	  '41739': [13.5623, 47.955],
	  '41740': [13.5721, 47.8042],
	  '41741': [13.4379, 47.9072],
	  '41742': [13.3077, 47.8763],
	  '41743': [13.6073, 48.0022],
	  '41744': [13.6222, 48.0476],
	  '41745': [13.5032, 47.8121],
	  '41746': [13.653, 48.0103],
	  '41747': [13.4892, 47.9885],
	  '41748': [13.4029, 47.9514],
	  '41749': [13.592, 47.887],
	  '41750': [13.6836, 48.1088],
	  '41751': [13.3654, 47.9172],
	  '41752': [13.592, 48.0747],
	  '41801': [13.7718, 48.117],
	  '41802': [13.7917, 48.1328],
	  '41803': [13.8915, 48.0529],
	  '41804': [14.0528, 48.2265],
	  '41805': [13.9972, 48.0338],
	  '41806': [13.9106, 48.104],
	  '41807': [13.9512, 48.0925],
	  '41808': [13.9299, 48.144],
	  '41809': [14.1037, 48.2197],
	  '41810': [13.9539, 48.1977],
	  '41811': [13.8728, 48.095],
	  '41812': [14.1247, 48.1966],
	  '41813': [13.8211, 48.0966],
	  '41814': [13.8727, 48.1537],
	  '41815': [13.865, 48.1293],
	  '41816': [13.9035, 48.1913],
	  '41817': [14.0542, 48.0751],
	  '41818': [14.0819, 48.16],
	  '41819': [14.0991, 48.108],
	  '41820': [13.8522, 48.0731],
	  '41821': [13.9871, 48.074],
	  '41822': [14.0122, 48.1128],
	  '41823': [14.0486, 48.1402],
	  '41824': [14.1153, 48.159],
	  '50101': [13.0429, 47.798],
	  '50201': [13.3679, 47.6055],
	  '50202': [13.1475, 47.6962],
	  '50203': [13.445, 47.5],
	  '50204': [13.1, 47.5557],
	  '50205': [13.1003, 47.6738],
	  '50206': [13.2157, 47.7076],
	  '50207': [13.1068, 47.6075],
	  '50208': [13.0988, 47.7012],
	  '50209': [13.1052, 47.73],
	  '50210': [13.4725, 47.5938],
	  '50211': [13.2617, 47.6577],
	  '50212': [13.2536, 47.5679],
	  '50213': [13.2046, 47.6715],
	  '50301': [13.0677, 47.7395],
	  '50302': [13.0118, 47.8895],
	  '50303': [13.0378, 47.8504],
	  '50304': [13.0654, 47.9976],
	  '50305': [12.9206, 47.9844],
	  '50306': [13.0186, 48.0173],
	  '50307': [13.1768, 47.7825],
	  '50308': [13.0597, 47.8724],
	  '50309': [13.1094, 47.7629],
	  '50310': [13.1409, 47.8548],
	  '50311': [13.2395, 47.7683],
	  '50312': [13.3033, 47.7948],
	  '50313': [12.9678, 47.9541],
	  '50314': [13.0262, 47.7373],
	  '50315': [12.9483, 47.7308],
	  '50316': [13.0861, 47.8492],
	  '50317': [13.2077, 47.8943],
	  '50318': [13.2937, 47.7129],
	  '50319': [13.2258, 47.8146],
	  '50320': [13.1939, 47.9567],
	  '50321': [13.1401, 47.8119],
	  '50322': [12.9713, 47.9994],
	  '50323': [13.1076, 47.9734],
	  '50324': [13.2465, 47.9325],
	  '50325': [12.9859, 47.927],
	  '50326': [12.935, 47.9484],
	  '50327': [13.0373, 47.9318],
	  '50328': [13.1737, 47.8358],
	  '50329': [12.8872, 47.9733],
	  '50330': [13.3964, 47.7633],
	  '50331': [13.1487, 47.9584],
	  '50332': [13.0582, 47.9597],
	  '50335': [13.2854, 47.9797],
	  '50336': [13.4596, 47.6915],
	  '50337': [13.2508, 47.8519],
	  '50338': [12.9726, 47.777],
	  '50339': [13.1158, 47.9075],
	  '50401': [13.4471, 47.3299],
	  '50402': [13.0971, 47.1728],
	  '50403': [13.1756, 47.0855],
	  '50404': [13.2084, 47.4153],
	  '50405': [13.0869, 47.2519],
	  '50406': [13.3843, 47.4192],
	  '50407': [13.5281, 47.4525],
	  '50408': [13.4091, 47.2485],
	  '50409': [13.5668, 47.3398],
	  '50410': [13.0696, 47.3213],
	  '50411': [13.2196, 47.2372],
	  '50412': [13.3182, 47.4065],
	  '50413': [13.2608, 47.1481],
	  '50414': [13.3187, 47.2666],
	  '50415': [13.1036, 47.3922],
	  '50416': [13.212, 47.4858],
	  '50417': [13.4835, 47.3868],
	  '50418': [13.2309, 47.3569],
	  '50419': [13.3575, 47.493],
	  '50420': [13.1341, 47.2919],
	  '50421': [13.1408, 47.3212],
	  '50422': [13.5087, 47.2628],
	  '50423': [13.3183, 47.3476],
	  '50424': [13.1131, 47.4698],
	  '50425': [13.2737, 47.4741],
	  '50501': [13.7531, 47.2246],
	  '50502': [13.8126, 47.2416],
	  '50503': [13.7348, 47.1532],
	  '50504': [13.6737, 47.1426],
	  '50505': [13.4146, 47.1092],
	  '50506': [13.8405, 47.0524],
	  '50507': [13.7901, 47.1517],
	  '50508': [13.6653, 47.0561],
	  '50509': [13.634, 47.0943],
	  '50510': [13.8744, 47.1503],
	  '50511': [13.7355, 47.0231],
	  '50512': [13.5567, 47.2114],
	  '50513': [13.7475, 47.1026],
	  '50514': [13.6364, 47.2437],
	  '50515': [13.5191, 47.1496],
	  '50601': [12.3476, 47.2811],
	  '50602': [12.8583, 47.2849],
	  '50603': [13.008, 47.3618],
	  '50604': [12.8265, 47.206],
	  '50605': [12.4087, 47.2189],
	  '50606': [12.7193, 47.1711],
	  '50607': [12.1475, 47.1952],
	  '50608': [13.0219, 47.2857],
	  '50609': [12.7308, 47.4339],
	  '50610': [12.6872, 47.6004],
	  '50611': [12.8019, 47.3672],
	  '50612': [12.9605, 47.4326],
	  '50613': [12.5002, 47.1917],
	  '50614': [12.2874, 47.1494],
	  '50615': [12.6429, 47.2508],
	  '50616': [12.71, 47.2995],
	  '50617': [12.9395, 47.1345],
	  '50618': [12.6241, 47.3681],
	  '50619': [12.8508, 47.4637],
	  '50620': [12.6998, 47.5388],
	  '50621': [12.5251, 47.2993],
	  '50622': [12.9533, 47.3165],
	  '50623': [12.6286, 47.6406],
	  '50624': [12.6174, 47.1705],
	  '50625': [12.7148, 47.3493],
	  '50626': [12.1783, 47.2683],
	  '50627': [12.7704, 47.5056],
	  '50628': [12.7957, 47.319],
	  '60101': [15.442, 47.0807],
	  '60301': [15.1442, 46.6781],
	  '60302': [15.2045, 46.8336],
	  '60303': [15.2381, 46.6805],
	  '60305': [15.2563, 46.8043],
	  '60306': [15.1507, 46.8474],
	  '60307': [15.1934, 46.8706],
	  '60308': [15.0624, 46.7881],
	  '60309': [15.2841, 46.9094],
	  '60310': [15.1988, 46.9449],
	  '60311': [15.1352, 46.7933],
	  '60312': [15.3356, 46.8366],
	  '60313': [15.268, 46.665],
	  '60314': [15.2407, 46.9535],
	  '60315': [15.2201, 46.7821],
	  '60316': [15.0848, 46.9007],
	  '60318': [15.3159, 46.9334],
	  '60319': [15.2224, 46.7417],
	  '60320': [15.1773, 46.9141],
	  '60321': [15.0504, 46.865],
	  '60322': [15.285, 46.6991],
	  '60323': [15.2985, 46.7277],
	  '60324': [15.4041, 46.8627],
	  '60325': [15.2802, 46.8679],
	  '60326': [15.3252, 46.9041],
	  '60327': [15.295, 46.7697],
	  '60328': [15.121, 46.7055],
	  '60329': [15.2611, 46.7627],
	  '60330': [15.2581, 46.9319],
	  '60331': [15.1946, 46.7557],
	  '60332': [15.0717, 46.6873],
	  '60333': [15.2472, 46.8916],
	  '60334': [15.3389, 46.8738],
	  '60335': [15.2801, 46.8901],
	  '60336': [15.3182, 46.7136],
	  '60338': [15.1388, 46.8221],
	  '60339': [15.3335, 46.7981],
	  '60340': [15.207, 46.7141],
	  '60341': [15.3874, 46.8354],
	  '60342': [15.1153, 46.7355],
	  '60343': [15.2444, 46.7176],
	  '60601': [15.3536, 47.0284],
	  '60602': [15.6292, 47.1248],
	  '60603': [15.2997, 47.1947],
	  '60604': [15.3655, 46.941],
	  '60605': [15.605, 47.0276],
	  '60606': [15.5992, 47.1184],
	  '60607': [15.267, 47.1326],
	  '60608': [15.4466, 47],
	  '60609': [15.5283, 46.9723],
	  '60610': [15.2677, 47.2918],
	  '60611': [15.484, 46.9949],
	  '60612': [15.5047, 47.0143],
	  '60613': [15.3574, 47.1494],
	  '60614': [15.3182, 47.127],
	  '60615': [15.2265, 47.1913],
	  '60616': [15.2096, 47.1555],
	  '60617': [15.5172, 47.0541],
	  '60618': [15.349, 46.9933],
	  '60619': [15.5128, 46.9867],
	  '60620': [15.3147, 47.0376],
	  '60621': [15.6213, 47.1005],
	  '60622': [15.3319, 47.1095],
	  '60623': [15.5507, 47.0947],
	  '60624': [15.4823, 46.9504],
	  '60625': [15.6389, 47.0293],
	  '60626': [15.5431, 47.18],
	  '60627': [15.6713, 47.0438],
	  '60628': [15.5732, 47.0708],
	  '60629': [15.3473, 46.9712],
	  '60630': [15.5143, 46.9513],
	  '60631': [15.62, 47.0705],
	  '60632': [15.3571, 47.2031],
	  '60633': [15.3765, 46.9959],
	  '60634': [15.5743, 47.1376],
	  '60635': [15.5366, 47.0349],
	  '60636': [15.3623, 47.3086],
	  '60637': [15.2933, 47.0636],
	  '60639': [15.26, 47.0806],
	  '60640': [15.7121, 47.0158],
	  '60641': [15.307, 47.0867],
	  '60642': [15.4775, 47.1845],
	  '60643': [15.3817, 47.2806],
	  '60644': [15.3774, 47.0139],
	  '60645': [15.4016, 47.2351],
	  '60646': [15.4197, 47.1482],
	  '60647': [15.2161, 47.115],
	  '60648': [15.3487, 47.0682],
	  '60649': [15.438, 47.2806],
	  '60650': [15.4193, 47.3214],
	  '60651': [15.1617, 47.2389],
	  '60652': [15.3915, 46.9739],
	  '60653': [15.5607, 47.0151],
	  '60654': [15.4762, 47.1417],
	  '60655': [15.4856, 46.9278],
	  '60656': [15.4451, 46.932],
	  '60657': [15.4231, 46.9557],
	  '60658': [15.4108, 46.9117],
	  '61001': [15.5549, 46.9142],
	  '61002': [15.4006, 46.6754],
	  '61003': [15.6008, 46.6969],
	  '61004': [15.6284, 46.8488],
	  '61005': [15.5836, 46.7217],
	  '61006': [15.4576, 46.6869],
	  '61007': [15.5974, 47.0031],
	  '61008': [15.6032, 46.8002],
	  '61009': [15.5275, 46.712],
	  '61010': [15.5237, 46.6565],
	  '61011': [15.3548, 46.742],
	  '61012': [15.5687, 46.8189],
	  '61013': [15.4498, 46.7373],
	  '61014': [15.6407, 46.8251],
	  '61015': [15.5773, 46.9426],
	  '61016': [15.4851, 46.7533],
	  '61017': [15.4479, 46.8662],
	  '61018': [15.5384, 46.7962],
	  '61019': [15.4591, 46.7805],
	  '61020': [15.5001, 46.8437],
	  '61021': [15.5416, 46.8411],
	  '61022': [15.5402, 46.7794],
	  '61023': [15.4667, 46.6678],
	  '61024': [15.3503, 46.6785],
	  '61025': [15.5832, 46.7447],
	  '61026': [15.3763, 46.7692],
	  '61027': [15.5946, 46.8466],
	  '61028': [15.571, 46.6933],
	  '61029': [15.5623, 46.7396],
	  '61030': [15.4093, 46.7972],
	  '61031': [15.5855, 46.8793],
	  '61032': [15.4005, 46.7083],
	  '61033': [15.4454, 46.8285],
	  '61034': [15.6598, 46.8023],
	  '61035': [15.5434, 46.9464],
	  '61036': [15.6363, 46.7629],
	  '61037': [15.4811, 46.6341],
	  '61038': [15.5255, 46.765],
	  '61039': [15.6281, 46.6998],
	  '61040': [15.5178, 46.9066],
	  '61041': [15.6355, 46.7241],
	  '61042': [15.5541, 46.679],
	  '61043': [15.5017, 46.8126],
	  '61044': [15.6036, 46.7353],
	  '61045': [15.5646, 46.7796],
	  '61046': [15.4737, 46.8973],
	  '61047': [15.5177, 46.8808],
	  '61048': [15.6744, 46.8434],
	  '61101': [14.8853, 47.5464],
	  '61104': [14.7357, 47.5904],
	  '61105': [14.7657, 47.463],
	  '61106': [14.9122, 47.3952],
	  '61107': [14.9257, 47.3174],
	  '61108': [15.1233, 47.3507],
	  '61109': [14.8191, 47.3933],
	  '61110': [15.1715, 47.3873],
	  '61111': [15.1328, 47.4162],
	  '61112': [14.755, 47.524],
	  '61113': [15.0174, 47.3332],
	  '61114': [15.0216, 47.3915],
	  '61115': [15.0449, 47.2677],
	  '61116': [14.996, 47.371],
	  '61118': [14.9689, 47.5137],
	  '61119': [14.6548, 47.4115],
	  '61120': [15.0318, 47.4462],
	  '61201': [14.4832, 47.5555],
	  '61202': [13.823, 47.4332],
	  '61203': [14.1607, 47.5111],
	  '61204': [13.7947, 47.6813],
	  '61205': [14.7126, 47.7249],
	  '61206': [14.3683, 47.6048],
	  '61207': [13.7824, 47.5849],
	  '61208': [14.1339, 47.4536],
	  '61209': [14.17, 47.3501],
	  '61210': [14.5453, 47.5],
	  '61211': [14.8514, 47.6602],
	  '61212': [13.8295, 47.3906],
	  '61213': [13.8463, 47.482],
	  '61214': [13.9833, 47.4104],
	  '61215': [13.9165, 47.66],
	  '61216': [14.4457, 47.6154],
	  '61217': [13.7634, 47.375],
	  '61218': [14.0785, 47.49],
	  '61219': [14.628, 47.5382],
	  '61220': [13.9077, 47.3026],
	  '61221': [14.7072, 47.6517],
	  '61222': [14.2612, 47.526],
	  '61223': [14.267, 47.5828],
	  '61224': [13.903, 47.4097],
	  '61225': [13.9669, 47.468],
	  '61226': [13.9291, 47.5361],
	  '61227': [14.039, 47.4692],
	  '61228': [14.0459, 47.4149],
	  '61229': [14.2909, 47.4338],
	  '61230': [14.8191, 47.7123],
	  '61232': [13.5991, 47.3974],
	  '61233': [13.8538, 47.5705],
	  '61234': [13.8732, 47.3832],
	  '61235': [14.0821, 47.5768],
	  '61236': [13.6592, 47.4338],
	  '61237': [13.7128, 47.3189],
	  '61238': [14.3756, 47.5066],
	  '61239': [14.6066, 47.6629],
	  '61240': [13.9966, 47.4993],
	  '61241': [14.0308, 47.327],
	  '61242': [13.686, 47.397],
	  '61243': [14.328, 47.5563],
	  '61244': [14.1065, 47.5438],
	  '61245': [14.0192, 47.6047],
	  '61246': [14.6018, 47.4661],
	  '61247': [14.4743, 47.4901],
	  '61248': [14.5042, 47.6579],
	  '61249': [14.1898, 47.5968],
	  '61250': [14.5337, 47.6154],
	  '61251': [14.9958, 47.6808],
	  '61252': [14.1586, 47.5626],
	  '61401': [14.4048, 47.0043],
	  '61403': [14.3011, 47.1389],
	  '61404': [14.0255, 47.2044],
	  '61405': [13.9439, 47.2181],
	  '61406': [13.9467, 47.176],
	  '61407': [14.4796, 47.0539],
	  '61408': [14.2099, 47.0964],
	  '61409': [14.394, 47.1013],
	  '61410': [14.539, 47.0347],
	  '61411': [14.1462, 47.1255],
	  '61412': [14.4202, 47.0738],
	  '61413': [14.3636, 47.1535],
	  '61414': [14.2961, 47.1904],
	  '61415': [14.299, 47.2376],
	  '61416': [14.4742, 47.1095],
	  '61417': [13.901, 46.9722],
	  '61418': [14.0925, 47.1553],
	  '61419': [14.1418, 47.1547],
	  '61420': [14.3221, 47.102],
	  '61421': [14.0938, 47.088],
	  '61422': [14.2966, 47.0619],
	  '61423': [14.4861, 47.1468],
	  '61424': [14.5156, 47.0877],
	  '61425': [14.1857, 47.1877],
	  '61427': [14.3982, 47.1702],
	  '61428': [14.0787, 47.2364],
	  '61429': [14.3536, 47.1971],
	  '61430': [14.0007, 47.0387],
	  '61431': [14.1841, 47.1294],
	  '61432': [14.3644, 47.1312],
	  '61433': [14.2307, 47.131],
	  '61434': [14.2178, 47.2504],
	  '61435': [14.3633, 47.0641],
	  '61436': [14.0055, 47.1094],
	  '61601': [15.1377, 47.0877],
	  '61602': [15.0497, 47.0065],
	  '61603': [15.0855, 47.1914],
	  '61604': [15.1538, 47.1734],
	  '61605': [14.9618, 47.0607],
	  '61606': [15.0248, 47.1249],
	  '61607': [14.9233, 47.0244],
	  '61608': [15.0244, 47.1718],
	  '61609': [15.0812, 47.072],
	  '61610': [15.1092, 47.1209],
	  '61611': [15.1801, 47.0091],
	  '61612': [15.1679, 46.9725],
	  '61613': [15.0423, 47.0747],
	  '61614': [15.0735, 46.9423],
	  '61615': [15.2772, 46.9754],
	  '61616': [15.0031, 46.9675],
	  '61617': [15.0859, 47.0975],
	  '61618': [15.1062, 47.051],
	  '61619': [14.9664, 47.1117],
	  '61620': [15.2407, 47.0132],
	  '61621': [15.1171, 47.0144],
	  '61622': [15.2745, 47.0002],
	  '61623': [15.1833, 47.1006],
	  '61624': [15.229, 47.0509],
	  '61625': [15.1668, 47.0464],
	  '61701': [15.7164, 47.1434],
	  '61702': [15.6893, 47.2769],
	  '61703': [15.5039, 47.2437],
	  '61704': [15.72, 47.285],
	  '61705': [15.6884, 47.3538],
	  '61706': [15.7016, 47.1829],
	  '61707': [15.7028, 47.2557],
	  '61708': [15.6414, 47.4413],
	  '61709': [15.4658, 47.3061],
	  '61710': [15.7449, 47.2547],
	  '61711': [15.574, 47.3834],
	  '61712': [15.8586, 47.1503],
	  '61713': [15.7109, 47.1082],
	  '61714': [15.7209, 47.3519],
	  '61715': [15.5386, 47.224],
	  '61716': [15.8476, 47.0468],
	  '61717': [15.6202, 47.3594],
	  '61718': [15.8266, 47.1893],
	  '61719': [15.7534, 47.0821],
	  '61720': [15.5225, 47.3136],
	  '61721': [15.7795, 47.1378],
	  '61722': [15.6937, 47.3148],
	  '61723': [15.6591, 47.2099],
	  '61724': [15.7686, 47.2099],
	  '61725': [15.7007, 47.0785],
	  '61726': [15.647, 47.0771],
	  '61727': [15.6744, 47.1078],
	  '61728': [15.7628, 47.3731],
	  '61729': [15.6137, 47.1729],
	  '61730': [15.5974, 47.207],
	  '61731': [15.5909, 47.2568],
	  '61732': [15.614, 47.3251],
	  '61733': [15.4573, 47.2437],
	  '61734': [15.7397, 47.1213],
	  '61735': [15.825, 47.1455],
	  '61736': [15.504, 47.273],
	  '61737': [15.8025, 47.1786],
	  '61739': [15.7421, 47.1743],
	  '61740': [15.7237, 47.2177],
	  '61741': [15.7314, 47.5141],
	  '61742': [15.7549, 47.1866],
	  '61743': [15.8439, 47.5324],
	  '61744': [15.6777, 47.4961],
	  '61745': [15.5891, 47.2963],
	  '61746': [15.7212, 47.0476],
	  '61747': [15.6519, 47.1378],
	  '61748': [15.8229, 47.1085],
	  '61749': [15.5075, 47.2076],
	  '61750': [15.7341, 47.4053],
	  '61751': [15.6466, 47.2482],
	  '61752': [15.6808, 47.0859],
	  '61753': [15.6745, 47.1699],
	  '61754': [15.6646, 47.3906],
	  '61755': [15.6306, 47.2167],
	  '62001': [14.7562, 47.0581],
	  '62002': [14.8371, 47.1903],
	  '62003': [14.3913, 47.3617],
	  '62004': [14.7581, 47.1145],
	  '62005': [14.897, 47.2674],
	  '62006': [14.7434, 47.2352],
	  '62007': [14.6874, 47.2147],
	  '62008': [14.6384, 47.3156],
	  '62009': [14.8045, 47.1844],
	  '62010': [14.5248, 47.4239],
	  '62011': [14.6558, 47.1767],
	  '62012': [14.9086, 47.1396],
	  '62013': [14.8217, 47.2123],
	  '62014': [14.8328, 47.2497],
	  '62015': [14.7716, 47.1653],
	  '62016': [14.61, 47.0784],
	  '62017': [14.5404, 47.2446],
	  '62018': [14.5648, 47.1041],
	  '62019': [14.4241, 47.2468],
	  '62020': [14.6141, 47.2221],
	  '62021': [14.3142, 47.324],
	  '62022': [14.9352, 47.1999],
	  '62023': [14.6716, 47.145],
	  '62024': [14.8506, 47.1062],
	  '62025': [14.618, 47.0344],
	  '62026': [14.5103, 47.1866],
	  '62027': [14.4858, 47.3622],
	  '62028': [14.9437, 47.2659],
	  '62029': [14.8656, 47.303],
	  '62030': [14.8557, 47.2274],
	  '62031': [14.5064, 47.2904],
	  '62032': [14.5757, 47.1575],
	  '62033': [14.6632, 47.1043],
	  '62034': [14.7952, 47.2881],
	  '62035': [14.7796, 47.2168],
	  '62036': [14.4315, 47.2001],
	  '62037': [14.7407, 47.1517],
	  '62038': [14.7356, 47.1878],
	  '62101': [15.2222, 47.5775],
	  '62102': [15.2796, 47.5619],
	  '62103': [15.4299, 47.4618],
	  '62104': [15.6335, 47.6927],
	  '62105': [15.4678, 47.3889],
	  '62106': [15.3101, 47.4083],
	  '62107': [15.1435, 47.5077],
	  '62108': [15.3694, 47.4245],
	  '62109': [15.7302, 47.5752],
	  '62110': [15.1995, 47.7023],
	  '62111': [15.3811, 47.7641],
	  '62112': [15.6913, 47.6618],
	  '62113': [15.2464, 47.4547],
	  '62114': [15.4318, 47.5202],
	  '62115': [15.5747, 47.5145],
	  '62116': [15.6064, 47.5904],
	  '62117': [15.3211, 47.7674],
	  '62118': [15.5127, 47.5384],
	  '62119': [15.3952, 47.4842],
	  '62120': [15.4594, 47.6895],
	  '62121': [15.6852, 47.6169],
	  '62122': [15.5821, 47.6397],
	  '62123': [15.2211, 47.3808],
	  '62124': [15.2839, 47.4895],
	  '62125': [15.3538, 47.3535],
	  '62126': [15.1206, 47.5954],
	  '62127': [15.1638, 47.4663],
	  '62128': [15.3629, 47.5004],
	  '62129': [15.3688, 47.4621],
	  '62130': [15.2394, 47.7737],
	  '62131': [15.7893, 47.6062],
	  '62132': [15.5342, 47.4546],
	  '62133': [15.2324, 47.5175],
	  '62134': [15.0198, 47.5713],
	  '62135': [15.3628, 47.5921],
	  '62136': [15.4786, 47.6125],
	  '62137': [15.4948, 47.5233],
	  '62201': [16.0499, 47.0769],
	  '62202': [16.0237, 47.1101],
	  '62203': [16.0141, 47.1581],
	  '62204': [15.8703, 47.1835],
	  '62205': [16.0052, 47.229],
	  '62206': [16.0878, 47.1412],
	  '62207': [16.0004, 47.4435],
	  '62208': [15.9111, 47.2462],
	  '62209': [15.955, 47.2019],
	  '62210': [15.9459, 47.3888],
	  '62211': [16.0522, 47.427],
	  '62212': [16.0882, 47.0498],
	  '62213': [15.9818, 47.3558],
	  '62214': [15.9282, 47.3181],
	  '62215': [15.9453, 47.1651],
	  '62216': [15.8973, 47.1485],
	  '62217': [15.9936, 47.0725],
	  '62218': [15.9441, 47.1162],
	  '62219': [15.9797, 47.2802],
	  '62220': [15.9206, 47.2845],
	  '62221': [15.8931, 47.2029],
	  '62222': [15.8825, 47.2363],
	  '62223': [15.9275, 47.0868],
	  '62224': [15.8426, 47.2015],
	  '62225': [15.9223, 47.2228],
	  '62226': [16.0308, 47.325],
	  '62227': [16.0458, 47.1888],
	  '62228': [16.1054, 47.017],
	  '62229': [15.8834, 47.4679],
	  '62230': [15.8778, 47.0859],
	  '62231': [16.0853, 47.1692],
	  '62232': [15.897, 47.0534],
	  '62233': [16.006, 47.4962],
	  '62234': [15.8354, 47.293],
	  '62235': [15.8594, 47.327],
	  '62236': [15.8934, 47.3805],
	  '62237': [15.7797, 47.2989],
	  '62238': [15.9133, 47.4216],
	  '62239': [16.0586, 47.2473],
	  '62240': [15.9982, 47.3813],
	  '62241': [15.7559, 47.3275],
	  '62242': [15.772, 47.4791],
	  '62243': [15.823, 47.2079],
	  '62244': [16.0455, 47.284],
	  '62245': [15.9454, 47.455],
	  '62246': [15.8479, 47.3777],
	  '62247': [16.0905, 47.4893],
	  '62248': [16, 47.4137],
	  '62249': [15.8604, 47.263],
	  '62250': [16.0088, 47.1911],
	  '62251': [15.7888, 47.2166],
	  '62252': [16.0024, 47.0319],
	  '62253': [15.8093, 47.3542],
	  '62254': [15.9181, 47.3492],
	  '62255': [16.0827, 46.9948],
	  '62256': [15.8011, 47.2443],
	  '62257': [15.8561, 47.2204],
	  '62258': [16.0516, 47.0186],
	  '62259': [15.8867, 47.4048],
	  '62260': [15.8435, 47.4212],
	  '62261': [15.8297, 47.4845],
	  '62262': [15.7878, 47.432],
	  '62263': [16.0694, 47.2134],
	  '62301': [15.8677, 47.0037],
	  '62302': [15.7872, 46.8494],
	  '62303': [15.907, 46.888],
	  '62304': [15.9926, 46.6878],
	  '62305': [15.9337, 46.8759],
	  '62306': [15.7622, 46.9082],
	  '62307': [15.7871, 46.8284],
	  '62308': [15.9519, 47.0379],
	  '62309': [15.8612, 46.7476],
	  '62310': [15.8165, 46.8057],
	  '62311': [15.8306, 46.9906],
	  '62312': [15.6258, 46.9665],
	  '62313': [15.7525, 46.7313],
	  '62314': [15.8017, 47.0273],
	  '62315': [16.0284, 46.9248],
	  '62316': [15.8895, 46.9537],
	  '62317': [15.7925, 46.9962],
	  '62318': [15.6246, 46.908],
	  '62319': [15.9389, 46.8278],
	  '62320': [15.685, 46.8698],
	  '62321': [15.8157, 46.886],
	  '62322': [15.8612, 46.9657],
	  '62323': [15.8051, 46.7265],
	  '62324': [15.9293, 46.9133],
	  '62325': [15.8246, 46.8434],
	  '62326': [15.925, 46.7314],
	  '62327': [16.0085, 46.9829],
	  '62328': [15.8948, 46.7893],
	  '62329': [16.0465, 46.958],
	  '62330': [15.7344, 46.8537],
	  '62331': [15.9812, 46.9569],
	  '62332': [15.9885, 46.8838],
	  '62333': [15.658, 46.9182],
	  '62334': [15.7627, 46.9787],
	  '62335': [15.9682, 46.7539],
	  '62336': [15.788, 46.9207],
	  '62337': [15.9031, 46.9801],
	  '62338': [15.8712, 46.8442],
	  '62339': [15.9307, 46.9425],
	  '62340': [15.968, 46.974],
	  '62341': [15.8518, 46.8992],
	  '62342': [15.9057, 46.8487],
	  '62343': [15.7062, 46.817],
	  '62344': [15.6386, 46.8793],
	  '62345': [15.8943, 46.9286],
	  '62346': [15.7679, 46.7091],
	  '62347': [15.7162, 46.7102],
	  '62348': [15.7256, 46.9866],
	  '62349': [15.783, 46.9609],
	  '62350': [15.7537, 46.9443],
	  '62351': [15.8165, 46.9195],
	  '62352': [15.9671, 46.9378],
	  '62353': [15.6685, 46.9944],
	  '62354': [15.6123, 46.9426],
	  '62355': [15.8568, 46.8614],
	  '62356': [15.9171, 46.9631],
	  '62357': [16.0212, 46.6841],
	  '62358': [15.8042, 46.8642],
	  '62359': [15.8047, 46.7621],
	  '62360': [15.9137, 47.0117],
	  '62361': [15.978, 46.8422],
	  '62362': [15.7679, 46.7989],
	  '62363': [15.7164, 46.9009],
	  '62364': [15.6622, 46.8774],
	  '62365': [15.9007, 46.821],
	  '62366': [15.8502, 46.7941],
	  '62367': [15.7573, 47.0062],
	  '62368': [15.9462, 46.7882],
	  '62369': [15.8815, 46.8763],
	  '62370': [15.8293, 46.8258],
	  '62371': [15.7708, 46.875],
	  '62372': [16.0879, 46.9682],
	  '62373': [15.709, 46.7624],
	  '62374': [15.6655, 46.958],
	  '70101': [11.3671, 47.2831],
	  '70201': [10.7608, 47.2003],
	  '70202': [10.8713, 47.2479],
	  '70203': [10.6937, 47.254],
	  '70204': [10.6957, 47.1946],
	  '70205': [10.7684, 47.1473],
	  '70206': [10.7894, 47.2222],
	  '70207': [10.7641, 47.2316],
	  '70208': [10.973, 47.0512],
	  '70209': [10.9641, 47.3245],
	  '70210': [10.6806, 47.2099],
	  '70211': [10.9471, 47.2828],
	  '70212': [10.7976, 47.3521],
	  '70213': [10.906, 47.3069],
	  '70214': [10.9079, 47.2051],
	  '70215': [11.0436, 47.2666],
	  '70216': [10.822, 47.1843],
	  '70217': [10.8564, 46.9317],
	  '70218': [10.8548, 47.2028],
	  '70219': [11.0004, 47.2046],
	  '70220': [10.9533, 46.8373],
	  '70221': [10.9942, 47.2716],
	  '70222': [10.7732, 47.3018],
	  '70223': [10.8908, 47.1433],
	  '70224': [10.7104, 47.1589],
	  '70301': [11.5187, 47.3312],
	  '70302': [11.4502, 47.2516],
	  '70303': [11.4818, 47.2634],
	  '70304': [11.2992, 47.1892],
	  '70305': [11.562, 47.3041],
	  '70306': [11.298, 47.2382],
	  '70307': [11.4875, 47.1936],
	  '70308': [11.1129, 47.2338],
	  '70309': [11.5859, 47.3091],
	  '70310': [11.3482, 47.1438],
	  '70311': [11.5815, 47.3309],
	  '70312': [11.3231, 47.2323],
	  '70313': [11.4748, 47.0428],
	  '70314': [11.1605, 47.1976],
	  '70315': [11.2647, 47.1711],
	  '70317': [11.3078, 47.0174],
	  '70318': [11.154, 47.2598],
	  '70319': [11.1915, 47.2678],
	  '70320': [11.2802, 47.2557],
	  '70322': [11.6259, 47.3028],
	  '70323': [11.6743, 47.2381],
	  '70325': [11.4546, 47.2225],
	  '70326': [11.1615, 47.3793],
	  '70327': [11.452, 47.1271],
	  '70328': [11.3922, 47.1495],
	  '70329': [11.5373, 47.2899],
	  '70330': [11.4208, 47.1226],
	  '70331': [11.364, 47.2086],
	  '70332': [11.3545, 47.236],
	  '70333': [11.5536, 47.138],
	  '70334': [11.1905, 47.0504],
	  '70335': [11.0897, 47.2504],
	  '70336': [11.3975, 46.9987],
	  '70337': [11.233, 47.2422],
	  '70338': [11.4172, 47.2051],
	  '70339': [11.1639, 47.296],
	  '70340': [11.077, 47.2942],
	  '70341': [11.4752, 47.1498],
	  '70342': [11.1465, 47.2775],
	  '70343': [11.2035, 47.2494],
	  '70344': [11.2204, 47.3139],
	  '70345': [11.5055, 47.2404],
	  '70346': [11.4187, 47.3111],
	  '70347': [11.1098, 47.1218],
	  '70348': [11.3711, 47.4024],
	  '70349': [11.6018, 47.0882],
	  '70350': [11.4053, 47.1845],
	  '70351': [11.2344, 47.3485],
	  '70352': [11.2004, 47.1606],
	  '70353': [11.4663, 47.2352],
	  '70354': [11.4961, 47.2808],
	  '70355': [11.4823, 47.0897],
	  '70356': [11.3317, 47.1723],
	  '70357': [11.0712, 47.3239],
	  '70358': [11.4666, 47.3057],
	  '70359': [11.3899, 47.0776],
	  '70360': [11.5397, 47.2542],
	  '70361': [11.2552, 47.2569],
	  '70362': [11.593, 47.0339],
	  '70364': [11.3192, 47.2525],
	  '70365': [11.5724, 47.2317],
	  '70366': [11.6258, 47.1918],
	  '70367': [11.601, 47.2559],
	  '70368': [11.015, 47.3364],
	  '70369': [11.273, 47.2872],
	  '70401': [12.4768, 47.409],
	  '70402': [12.2494, 47.4549],
	  '70403': [12.5507, 47.4509],
	  '70404': [12.3434, 47.5302],
	  '70405': [12.6598, 47.4838],
	  '70406': [12.1259, 47.3455],
	  '70407': [12.1549, 47.4734],
	  '70408': [12.4016, 47.3591],
	  '70409': [12.3, 47.3512],
	  '70410': [12.4665, 47.5745],
	  '70411': [12.3923, 47.4471],
	  '70412': [12.4083, 47.671],
	  '70413': [12.3924, 47.4913],
	  '70414': [12.3423, 47.4787],
	  '70415': [12.5526, 47.5008],
	  '70416': [12.4584, 47.5021],
	  '70417': [12.6059, 47.525],
	  '70418': [12.3978, 47.6133],
	  '70419': [12.6218, 47.5749],
	  '70420': [12.2198, 47.3789],
	  '70501': [11.9651, 47.3594],
	  '70502': [12.0688, 47.5143],
	  '70503': [12.1196, 47.5064],
	  '70504': [11.8954, 47.5399],
	  '70505': [11.9849, 47.4981],
	  '70506': [11.9336, 47.4276],
	  '70508': [12.2432, 47.62],
	  '70509': [12.2882, 47.5015],
	  '70510': [12.1885, 47.6864],
	  '70511': [12.084, 47.5026],
	  '70512': [11.8682, 47.4523],
	  '70513': [12.1768, 47.5787],
	  '70514': [11.997, 47.4647],
	  '70515': [12.078, 47.543],
	  '70516': [12.0451, 47.5402],
	  '70517': [11.8101, 47.4427],
	  '70518': [12.2094, 47.653],
	  '70519': [12.2367, 47.6716],
	  '70520': [11.9397, 47.449],
	  '70521': [11.8902, 47.4387],
	  '70522': [11.8854, 47.4035],
	  '70523': [12.2718, 47.6697],
	  '70524': [12.2341, 47.5417],
	  '70525': [12.1489, 47.5347],
	  '70526': [12.2099, 47.5005],
	  '70527': [11.9964, 47.5805],
	  '70528': [12.0269, 47.5213],
	  '70529': [12.3088, 47.6275],
	  '70530': [12.0238, 47.4209],
	  '70531': [12.0651, 47.4815],
	  '70601': [10.674, 47.0981],
	  '70602': [10.6956, 47.0369],
	  '70603': [10.5979, 47.0748],
	  '70604': [10.6505, 47.1259],
	  '70605': [10.4044, 47.1188],
	  '70606': [10.1706, 46.9143],
	  '70607': [10.5019, 47.1558],
	  '70608': [10.2856, 46.9939],
	  '70609': [10.3492, 47.0611],
	  '70610': [10.7109, 47.0934],
	  '70611': [10.7223, 46.9145],
	  '70612': [10.7229, 47.0616],
	  '70613': [10.6437, 47.0715],
	  '70614': [10.5589, 47.1224],
	  '70615': [10.5329, 46.8882],
	  '70616': [10.3545, 47.1486],
	  '70617': [10.6131, 46.9477],
	  '70618': [10.5068, 47.1315],
	  '70619': [10.6714, 47.0701],
	  '70620': [10.651, 47.0331],
	  '70621': [10.2252, 47.0848],
	  '70622': [10.6415, 47.2058],
	  '70623': [10.4401, 47.0438],
	  '70624': [10.5686, 47.0334],
	  '70625': [10.4305, 46.9948],
	  '70626': [10.5507, 47.1546],
	  '70627': [10.4589, 47.1235],
	  '70628': [10.5169, 47.1078],
	  '70629': [10.6226, 47.003],
	  '70630': [10.5511, 47.2023],
	  '70701': [12.5193, 46.758],
	  '70702': [12.7022, 46.9019],
	  '70703': [12.7622, 46.7645],
	  '70704': [12.5652, 46.764],
	  '70705': [12.644, 46.7959],
	  '70706': [12.4432, 46.8052],
	  '70707': [12.8579, 46.8139],
	  '70708': [12.7843, 46.8462],
	  '70709': [12.5074, 46.8958],
	  '70710': [12.3584, 46.8329],
	  '70711': [12.8618, 46.8374],
	  '70712': [12.6669, 47.0165],
	  '70713': [12.5062, 46.7089],
	  '70714': [12.8429, 46.784],
	  '70715': [12.7123, 46.7593],
	  '70716': [12.761, 46.83],
	  '70717': [12.4887, 47.0911],
	  '70718': [12.9087, 46.798],
	  '70719': [12.7559, 46.9274],
	  '70720': [12.6724, 46.8461],
	  '70721': [12.601, 46.7021],
	  '70723': [12.3042, 47.032],
	  '70724': [12.2864, 46.9302],
	  '70725': [12.6385, 46.9206],
	  '70726': [12.4081, 46.9234],
	  '70727': [12.6201, 46.8737],
	  '70728': [12.4001, 46.7479],
	  '70729': [12.4921, 46.7587],
	  '70731': [12.765, 46.8798],
	  '70732': [12.7998, 46.7944],
	  '70733': [12.6654, 46.6746],
	  '70734': [12.4447, 46.983],
	  '70735': [12.4522, 46.7622],
	  '70801': [10.3885, 47.2474],
	  '70802': [10.7409, 47.3854],
	  '70803': [10.8785, 47.3631],
	  '70804': [10.8121, 47.422],
	  '70805': [10.7556, 47.4796],
	  '70806': [10.7107, 47.4719],
	  '70807': [10.9413, 47.3924],
	  '70808': [10.4166, 47.3017],
	  '70809': [10.539, 47.3457],
	  '70810': [10.6007, 47.4161],
	  '70811': [10.563, 47.5049],
	  '70812': [10.5292, 47.2652],
	  '70813': [10.4829, 47.3128],
	  '70814': [10.7387, 47.4437],
	  '70815': [10.4273, 47.3533],
	  '70816': [10.6679, 47.4677],
	  '70817': [10.3278, 47.2833],
	  '70818': [10.4564, 47.5732],
	  '70819': [10.2908, 47.1952],
	  '70820': [10.6901, 47.5028],
	  '70821': [10.8887, 47.4535],
	  '70822': [10.6674, 47.5216],
	  '70823': [10.6676, 47.3584],
	  '70824': [10.6049, 47.4822],
	  '70825': [10.5827, 47.3095],
	  '70826': [10.739, 47.5206],
	  '70827': [10.7043, 47.5348],
	  '70828': [10.6634, 47.4002],
	  '70829': [10.4597, 47.5246],
	  '70830': [10.6167, 47.3481],
	  '70831': [10.2545, 47.2381],
	  '70832': [10.5042, 47.4798],
	  '70833': [10.6135, 47.5401],
	  '70834': [10.5288, 47.3814],
	  '70835': [10.6617, 47.4881],
	  '70836': [10.4907, 47.4104],
	  '70837': [10.457, 47.4915],
	  '70901': [11.6851, 47.5477],
	  '70902': [11.8655, 47.2648],
	  '70903': [12.0191, 47.1003],
	  '70904': [11.8665, 47.3796],
	  '70905': [11.7941, 47.3748],
	  '70907': [11.5946, 47.4787],
	  '70908': [11.7096, 47.0297],
	  '70909': [11.852, 47.3451],
	  '70910': [11.8047, 47.3265],
	  '70911': [11.7716, 47.3544],
	  '70912': [12.0343, 47.2078],
	  '70913': [11.9629, 47.225],
	  '70914': [11.9473, 47.1964],
	  '70915': [11.893, 47.3476],
	  '70916': [11.8128, 47.2169],
	  '70917': [11.7664, 47.3958],
	  '70918': [11.8487, 47.2838],
	  '70920': [11.8756, 47.0822],
	  '70921': [11.758, 47.286],
	  '70922': [11.8884, 47.1988],
	  '70923': [11.8646, 47.3049],
	  '70924': [11.9177, 47.2434],
	  '70925': [11.8368, 47.3776],
	  '70926': [11.7307, 47.3417],
	  '70927': [11.8012, 47.1811],
	  '70928': [11.7236, 47.3817],
	  '70929': [11.7856, 47.5079],
	  '70930': [11.8111, 47.3927],
	  '70931': [11.8826, 47.3073],
	  '70932': [11.9686, 47.2861],
	  '70933': [11.6311, 47.3303],
	  '70934': [11.6878, 47.1249],
	  '70935': [11.8505, 47.3168],
	  '70936': [11.5016, 47.4258],
	  '70937': [11.6507, 47.3088],
	  '70938': [11.7022, 47.2837],
	  '70939': [11.7931, 47.4105],
	  '70940': [11.8867, 47.2319],
	  '70941': [11.8632, 47.2402],
	  '80101': [9.9146, 47.1074],
	  '80102': [9.8475, 47.2354],
	  '80103': [9.8442, 47.1568],
	  '80104': [9.728, 47.1954],
	  '80105': [9.7193, 47.0836],
	  '80106': [9.7919, 47.115],
	  '80107': [9.7587, 47.1397],
	  '80108': [10.023, 47.1574],
	  '80109': [9.9259, 47.2659],
	  '80110': [10.0695, 46.9718],
	  '80111': [9.9363, 47.1432],
	  '80112': [10.1192, 47.1242],
	  '80113': [10.1566, 47.2137],
	  '80114': [9.8365, 47.1263],
	  '80115': [9.7937, 47.1939],
	  '80116': [9.682, 47.1565],
	  '80117': [9.8288, 47.1832],
	  '80118': [9.9199, 47.1908],
	  '80119': [9.868, 47.1182],
	  '80120': [9.9421, 46.9783],
	  '80121': [9.8083, 47.2364],
	  '80122': [9.9552, 47.0646],
	  '80123': [10.043, 47.066],
	  '80124': [9.9888, 47.2346],
	  '80125': [9.8626, 47.1377],
	  '80126': [9.7668, 47.2034],
	  '80127': [9.7772, 47.2243],
	  '80128': [9.8751, 47.0487],
	  '80129': [9.7848, 47.06],
	  '80201': [9.8405, 47.4563],
	  '80202': [9.8967, 47.4054],
	  '80203': [9.9648, 47.3123],
	  '80204': [10.0344, 47.362],
	  '80205': [9.7978, 47.4608],
	  '80206': [9.9721, 47.3678],
	  '80207': [9.723, 47.5126],
	  '80208': [9.8122, 47.481],
	  '80209': [9.8757, 47.2951],
	  '80210': [9.8724, 47.4963],
	  '80211': [9.97, 47.4194],
	  '80212': [9.7952, 47.5361],
	  '80213': [9.637, 47.5049],
	  '80214': [9.569, 47.5261],
	  '80215': [9.6878, 47.4898],
	  '80216': [9.9913, 47.4597],
	  '80217': [9.6188, 47.4847],
	  '80218': [9.7569, 47.5515],
	  '80219': [9.7776, 47.5791],
	  '80220': [9.7681, 47.4822],
	  '80221': [9.9219, 47.485],
	  '80222': [9.8386, 47.526],
	  '80223': [9.8952, 47.4661],
	  '80224': [9.7156, 47.4695],
	  '80225': [9.91, 47.4497],
	  '80226': [9.7699, 47.5161],
	  '80227': [9.8563, 47.3359],
	  '80228': [10.1471, 47.3153],
	  '80229': [9.805, 47.5662],
	  '80230': [9.8768, 47.3753],
	  '80231': [9.9588, 47.503],
	  '80232': [9.9276, 47.343],
	  '80233': [10.0409, 47.2948],
	  '80234': [10.0897, 47.2578],
	  '80235': [9.7656, 47.4491],
	  '80236': [9.8371, 47.4163],
	  '80237': [10.0514, 47.4258],
	  '80238': [9.8956, 47.524],
	  '80239': [10.1453, 47.2639],
	  '80240': [9.7455, 47.4587],
	  '80301': [9.7588, 47.409],
	  '80302': [9.6968, 47.3677],
	  '80303': [9.6712, 47.4328],
	  '80401': [9.6479, 47.3573],
	  '80402': [9.712, 47.2237],
	  '80403': [9.7322, 47.2334],
	  '80404': [9.5896, 47.2542],
	  '80405': [9.5997, 47.1834],
	  '80406': [9.687, 47.3217],
	  '80407': [9.6292, 47.2371],
	  '80408': [9.6454, 47.3352],
	  '80409': [9.6428, 47.3134],
	  '80410': [9.6109, 47.3232],
	  '80411': [9.7541, 47.2614],
	  '80412': [9.6212, 47.3537],
	  '80413': [9.5812, 47.3016],
	  '80414': [9.6076, 47.2869],
	  '80415': [9.6943, 47.2185],
	  '80416': [9.6637, 47.2954],
	  '80417': [9.6693, 47.2276],
	  '80418': [9.701, 47.2045],
	  '80419': [9.7338, 47.2134],
	  '80420': [9.634, 47.2938],
	  '80421': [9.6789, 47.2538],
	  '80422': [9.7274, 47.3141],
	  '80423': [9.6614, 47.3064],
	  '80424': [9.7155, 47.2896],
	  '90001': [16.3732, 48.2068],
	  AT111: [16.48771355828092, 47.52420512423763],
	  AT112: [16.79928982143564, 47.8531292362249],
	  AT113: [16.25958621705921, 47.18304370827477],
	  AT121: [14.961320902384855, 47.97058077781359],
	  AT122: [15.994565432169876, 47.78379113654571],
	  AT123: [15.640601806503565, 48.20848779605197],
	  AT124: [15.32907467460579, 48.666190392891004],
	  AT125: [16.54635009344655, 48.64215101236349],
	  AT126: [16.304704374930612, 48.41942575538995],
	  AT127: [16.34614810579569, 48.01334695434376],
	  AT131: [16.37766818782111, 48.20755975434235],
	  AT211: [13.774919486261833, 46.653233814576566],
	  AT212: [13.207529160547073, 46.80788136937481],
	  AT213: [14.703789544875246, 46.79828806922963],
	  AT221: [15.382248886737548, 47.107940018013906],
	  AT222: [14.085880455129429, 47.44510842475714],
	  AT223: [15.335228223388924, 47.5709781402357],
	  AT224: [15.864878776404788, 47.19461873678338],
	  AT225: [15.192450466342628, 46.84392057768649],
	  AT226: [14.44091959769469, 47.2293459248682],
	  AT311: [13.617890754120015, 48.34534238345576],
	  AT312: [14.178431136768076, 48.26412959452543],
	  AT313: [14.689767995126138, 48.37169800113601],
	  AT314: [14.320506224218882, 47.85753762340491],
	  AT315: [13.699749771358936, 47.898985748325444],
	  AT321: [13.694574875632247, 47.150758385761684],
	  AT322: [12.900512413830853, 47.29256009244694],
	  AT323: [13.235143727454023, 47.69681867001293],
	  AT331: [10.57739951547717, 47.43262886400382],
	  AT332: [11.350468660162967, 47.19875494603301],
	  AT333: [12.52178422099173, 46.912856910742484],
	  AT334: [10.794399494411671, 47.08730938323455],
	  AT335: [11.90515153450588, 47.37839644352246],
	  AT341: [9.992118509736493, 47.17800384801701],
	  AT342: [9.741249526242402, 47.3803792766059]
	};
	module.exports = exports['default'];

/***/ }),

/***/ 147:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  Anz_Krippe: {
	    d: 'm -1,1 2,0 0,-2 -2,0 z',
	    fill: '#be0021',
	    label: 'Kinderkrippen',
	    order: 0
	  },
	  Anz_KiGa: {
	    d: 'M -1.16,1 1.16,1 0,-1 Z',
	    fill: '#a9c571',
	    label: 'Kindergärten',
	    order: 1
	  },
	  Anz_alterserw_KiGa: {
	    d: 'M -1,0 A 1,1 0 1 0 1,0 1,1 0 1 0 -1,0',
	    fill: '#009bd2',
	    label: 'alterserweiterte KiGa',
	    order: 2
	  },
	  VS_Ki_NMB_vorh: {
	    d: 'm 0.5,-1 0,0.5 0.5,0 0,1 -0.5,0 0,0.5 -1,0 0,-0.5 -0.5,0 0,-1 0.5,0 0,-0.5 z',
	    fill: '#ff9900',
	    label: 'Horte & schulische Betreuung',
	    order: 3
	  }
	};
	module.exports = exports['default'];

/***/ }),

/***/ 354:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(18);
	
	var _SymbolAtlas = __webpack_require__(99);
	
	var _SymbolAtlas2 = _interopRequireDefault(_SymbolAtlas);
	
	var _SymbolLegend = __webpack_require__(97);
	
	var _SymbolLegend2 = _interopRequireDefault(_SymbolLegend);
	
	var _Popup = __webpack_require__(78);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _Quelle = __webpack_require__(23);
	
	var _Quelle2 = _interopRequireDefault(_Quelle);
	
	var _symbols = __webpack_require__(147);
	
	var _symbols2 = _interopRequireDefault(_symbols);
	
	var _bezirke = __webpack_require__(41);
	
	var _bezirke2 = _interopRequireDefault(_bezirke);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Betreuungseinrichtungen = function (_React$Component) {
	  _inherits(Betreuungseinrichtungen, _React$Component);
	
	  function Betreuungseinrichtungen() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Betreuungseinrichtungen);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.clickOnGemeinde = function (iso) {
	      var bezirk = _bezirke2.default.find(function (b) {
	        return b.filter(iso);
	      });
	      if (bezirk.zoomToIso === _this.props.pathContext.zoomToIso) {
	        _this.openPopup(iso);
	      } else {
	        _this.setZoomToIso(bezirk.zoomToIso);
	      }
	    }, _this.setZoomToIso = function () {
	      var iso = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	      var path = _this.props.data.allSite.edges.find(function (e) {
	        return e.node.fields && e.node.fields.zoomToIso === iso && e.node.fields.showPopup === false;
	      }).node.path;
	      (0, _gatsbyLink.navigateTo)(path);
	    }, _this.closePopup = function () {
	      var path = _this.props.data.allSite.edges.find(function (e) {
	        return e.node.fields && e.node.fields.zoomToIso === _this.props.pathContext.zoomToIso && e.node.fields.showPopup === false;
	      }).node.path;
	      (0, _gatsbyLink.navigateTo)(path);
	    }, _this.openPopup = function (iso) {
	      var path = _this.props.data.allSite.edges.find(function (e) {
	        return e.node.fields && e.node.fields.popup === Number(iso) && e.node.fields.showPopup === true;
	      }).node.path;
	      (0, _gatsbyLink.navigateTo)(path);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Betreuungseinrichtungen.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'content-box' },
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Betreuungseinrichtungen'
	      ),
	      this.props.pathContext.showPopup ? _react2.default.createElement(_Popup2.default, {
	        closePopup: this.closePopup,
	        data: this.props.data,
	        openPopup: this.openPopup,
	        menu: '1'
	      }) : null,
	      _react2.default.createElement(
	        'div',
	        { style: { breakAfter: false } },
	        _react2.default.createElement(_SymbolLegend2.default, {
	          symbols: _symbols2.default,
	          label: '' + (this.props.pathContext.name ? 'Bezirk ' + this.props.pathContext.name : 'Burgenland')
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'content-map-div' },
	          _react2.default.createElement(_SymbolAtlas2.default, {
	            data: this.props.data.alleGemeinden.edges,
	            symbols: _symbols2.default,
	            zoomToIso: this.props.pathContext.zoomToIso,
	            setZoomToIso: this.setZoomToIso,
	            clickOnGemeinde: this.clickOnGemeinde
	          })
	        )
	      ),
	      _react2.default.createElement(
	        _Quelle2.default,
	        null,
	        'Quelle: Amt der Burgenl\xE4ndischen Landesregierung, Kindertagesheimstatistik 2025/2026; Gemeindekooperationen: telefonische Erhebung bei den Gemeinde\xE4mtern (Oktober 2017)'
	      )
	    );
	  };
	
	  return Betreuungseinrichtungen;
	}(_react2.default.Component);
	
	exports.default = Betreuungseinrichtungen;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-facilities-js-98a4e07e37c0f6c02a29.js